import {
  Component,
  ElementRef,
  inject,
  Input,
  SimpleChanges,
  ViewChild,
} from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { HttpClient } from "@angular/common/http";
import {
  DiscussionMasterDTO,
  DiscussionMasterDeleteRequestDTO,
  DiscussionMasterUpdateRequestDTO,
  DiscussionMasterCreateRequestDTO,
  DiscussionMasterReadByMasterIdRequestDTO,
  DiscussionMasterList,
  DiscussionMasterReadByIdRequestDTO,
  DiscussionMasterReadByUserIdRequestDTO,
  DiscussionDTO,
  DiscussionList,
  DiscussionMasterGetDiscussionUserListRequestDTO,
  DiscussionUserDTO,
  DiscussionMasterCreateGroupRequestDTO,
  DiscussionListingDTO,
  DiscussionListing,
} from "./discussion-master.interface";
import { UserLoginService } from "src/app/login/userlogin.service";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { ToastrService } from "ngx-toastr";
import { ConfirmmodalserviceService } from "../confirm-delete-modal/confirmdeletemodal.service";
import { DiscussionMasterService } from "./discussion-master.service";
import {
  DiscussionDetailDeleteRequestDTO,
  DiscussionDetailDTO,
  DiscussionDetailList,
  DiscussionDetailReadByDiscussionIdRequestDTO,
  DiscussionDetailUpdateRequestDTO,
} from "./discussion-detail.interface";
import { DiscussionDetailService } from "./discussion-detail.service";
import {
  debounceTime,
  distinctUntilChanged,
  first,
  firstValueFrom,
  Subject,
  Subscription,
} from "rxjs";
import { UserMasterDTO } from "src/app/master/users/users.interface";
import {
  ClassMasterDTO,
  ClassMasterReadBySchoolIdRequestDTO,
} from "src/app/School/BackOffice/class-master/class-master.interface";
import { SectionMasterDTO } from "src/app/School/BackOffice/section-master/section-master.interface";
import {
  StudentClassMappingDTO,
  StudentClassMappingReadByClassIdRequestDTO,
  StudentClassMappingReadByUserIdRequestDTO,
} from "src/app/School/BackOffice/student-master/student-class-mapping/student-class-mapping.interface";
import {
  UserAffiliationMappingDTO,
  UserAffiliationMappingReadByUserIdRequestDTO,
  UserAffiliationMappingReadUserBySchoolIdRequestDTO,
} from "src/app/School/SchoolUserMapping/user-affiliation-mapping.interface";
import {
  TeacherClassSubjectMappingDTO,
  TeacherClassSubjectMappingReadByClassIdRequestDTO,
} from "src/app/School/Business/teaching-staff-master/teacher-class-subject-mapping/teacher-class-subject-mapping.interface";
import { TeacherClassSubjectMappingService } from "src/app/School/Business/teaching-staff-master/teacher-class-subject-mapping/teacher-class-subject-mapping.service";
import { StudentClassMappingService } from "src/app/School/BackOffice/student-master/student-class-mapping/student-class-mapping.service";
import { ParentStudentMappingService } from "src/app/School/BackOffice/parent-master/children/parent-student-mapping.service";
import { UserAffiliationMappingService } from "src/app/School/SchoolUserMapping/user-affiliation-mapping.service";
import { ActivatedRoute } from "@angular/router";
import { ParentStudentMappingDTO } from "src/app/School/BackOffice/parent-master/children/parent-student-mapping.interface";
import { ClassMasterService } from "src/app/School/BackOffice/class-master/class-master.service";
import { SectionMasterService } from "src/app/School/BackOffice/section-master/section-master.service";
import { DiscussionParticipantsService } from "./discussion-participants.service";
import {
  DiscussionParticipantsDTO,
  DiscussionParticipantsCreateRequestDTO,
  DiscussionParticipantsDeleteRequestDTO,
} from "./discussion-participants.interface";
import { DiscussionSignalRService } from "./discussion-signalr.service";
import { discussionDetailReadByDiscussionIdRequestDTO } from "src/app/housing-society/Interface & Service/discussion-detail/discussion-detail.interface";
import { DiscussionListService } from "./discussionlist.service";
import { NotificationMasterService } from "src/app/Common/NotificationMaster/notificationMaster.service";
import { PushNotificationSendMessageRequestDTO } from "src/app/Common/NotificationMaster/notificationMaster.interface";

@Component({
  selector: "app-discussion",
  templateUrl: "./discussion.component.html",
  styleUrls: ["./discussion.component.css"],
})
export class DiscussionComponent {
  userPageSize = 10;
  isUserFetchingMore = false;
  hasMoreUsers = true;

  isFetchingMore = false;
  hasMoreDiscussions = true;

  private lastMarkedReadDetailId: number | null = null;
  private schoolUserAffiliationMappingService = inject(
    UserAffiliationMappingService,
  );
  hasMoreOldMessages = true;
  pageSize = 20;
  lastDetailId: number | null = null;
  isLoadingOld = false;
  initialLoad = true;

  wsSubscription!: Subscription;
  wsChatSubscription!: Subscription;
  chatListWebSocketService = inject(DiscussionListService);
  notificationMasterService = inject(NotificationMasterService);

  webSocketService = inject(DiscussionSignalRService);
  previousDiscussionId?: number;

  isMsgGrouping: boolean = false;

  isSingleSelectMode = false;

  currentStudentMapping: { classId: number; sectionId: number | null } | null =
    null;

  private messageSearchSubject = new Subject<string>();

  showMessageSearch = false;
  searchMessageText = "";
  searchResults: HTMLElement[] = [];
  currentMatchIndex = 0;
  participantsList: DiscussionParticipantsDTO[] = [];
  loadingParticipants = false;
  discussionParticipantsService = inject(DiscussionParticipantsService);
  dontShowSelect = false;
  groupChatCreating = false;
  chatCreating = false;
  selectedCount = 0;
  selectedUserIds: number[] = [];

  userList: DiscussionUserDTO[] = [];
  loadingSections = false;
  sectionList: SectionMasterDTO[] = [];
  sectionMasterService = inject(SectionMasterService);
  classService = inject(ClassMasterService);
  classList: ClassMasterDTO[] = [];
  allowedListTypes: string[] = [];
  showListType = false;
  showClassSection: boolean = false;
  teacherClassId: number = 0;
  teacherSectionId: number = 0;
  isPanelOpen: boolean = false;

  isGroupChat = false;
  masterId: number | null = null;
  masterType!: string;
  showAssignedTeacherFilter = false;
  userListLoading = false;
  isStudentMappingLoading = false;
  isTeacherLoading = false;
  route = inject(ActivatedRoute);
  userData: UserAffiliationMappingDTO[] = [];
  schoolUserMappingService = inject(UserAffiliationMappingService);
  parentLoading = false;
  parentStudentMappingService = inject(ParentStudentMappingService);
  studentClassMappingService = inject(StudentClassMappingService);
  isStudentLoading = false;
  searchClassId: number = 0;
  searchSectionId: number | null = null;
  searchStudentId: number = 0;
  noClassAssigned = false;
  isClassLoading = false;
  teacherClassSubjectList: TeacherClassSubjectMappingDTO[] = [];
  assignedTeacherList: TeacherClassSubjectMappingDTO[] = [];
  teacherClassSubjectMapping = inject(TeacherClassSubjectMappingService);
  teacherId: number = 0;
  selectedClassId!: number;
  selectedSectionId!: number;
  selectedStudentId!: number;
  selectedTeacherId!: number;
  selectedParentId!: number;
  selectedStaffId!: number;
  showClassFilter = false;
  showSectionFilter = false;
  showStudentFilter = false;
  showTeacherFilter = false;
  showStaffFilter = false;
  showStaffMemberFilter = false;
  showParentFilter = false;

  selectedDiscussionType: string | null = null;
  masterIdToShow: number | null = null;

  userCache: { [userId: string]: UserMasterDTO } = {};

  discussionDetails: DiscussionDetailDTO[] = [];
  private currentLoadToken = 0;
  discussionId!: number;
  private refreshInterval: any;
  discussionDetailService = inject(DiscussionDetailService);
  editMessageId: number | null = null;
  editMessageText: string = "";
  isChatLoading = false;
  @ViewChild("bottomAnchor") bottomAnchor!: ElementRef;
  @ViewChild("messageComposer") messageComposer?: ElementRef<HTMLTextAreaElement>;
  @ViewChild("attachmentFileInput") attachmentFileInput?: ElementRef<HTMLInputElement>;

  private http = inject(HttpClient);

  // Upload to Nishwik ImageMaster first, then save the returned URL via SCL/DD/Create.
  @Input() attachmentUploadUrl = "https://dev.apig.nishwik.com/M/IM/Upload";
  selectedAttachment: File | null = null;
  selectedAttachmentPreviewUrl: string | null = null;
  readonly maxAttachmentBytes = 10 * 1024 * 1024;
  showEmojiPicker = false;
  readonly emojis = [
    "😀", "😁", "😂", "😊", "😍", "🥰", "😘", "😎", "🤔", "😢", "😭", "😡",
    "👍", "👎", "👏", "🙏", "🙌", "❤️", "💙", "💯", "✅", "🎉", "🌹", "🔥",
  ];

  isRecording = false;
  isVoiceToTextListening = false;
  voiceStatus = "";
  private speechRecognition: any = null;
  private dictationBaseText = "";
  private recorder: MediaRecorder | null = null;
  private recordingStream: MediaStream | null = null;
  private recordedChunks: Blob[] = [];

  private refreshInFlight = false;
  private isComponentDestroyed = false;
  private localDeletedMessageIds = new Set<number>();
  groupedMessages: { label: string; messages: DiscussionDetailDTO[] }[] = [];

  discussions: DiscussionListingDTO[] = [];
  isSubmitting = false;
  discussionLoading = false;
  discussionMasterService = inject(DiscussionMasterService);
  @Input() selectedSchoolId!: number;
  @Input() studentId!: number;
  @Input() affiliationType!: string;
  @Input() currentUserId!: number;
  modalService = inject(NgbModal);
  confirmModal = inject(ConfirmmodalserviceService);
  discussionOptions: { value: string; label: string }[] = [];

  toastr = inject(ToastrService);
  discussionForm = new FormGroup({
    discussionId: new FormControl(0),
    masterType: new FormControl(""),
    masterId: new FormControl(0),
    discTitle: new FormControl("", [
      Validators.required,
      Validators.maxLength(250),
    ]),
    discDesc: new FormControl("", [Validators.maxLength(2000)]),
    canMembersPost: new FormControl(true),
    postedBy: new FormControl(""),
    postedAt: new FormControl(""),
    actionUser: new FormControl(""),
    otherDetail1: new FormControl(""),
    otherDetail2: new FormControl(""),
    otherDetail3: new FormControl(""),
    otherDetail4: new FormControl(""),
    otherDetail5: new FormControl(""),
    otherDetail6: new FormControl(""),
  });
  userLoginService = inject(UserLoginService);
  user = this.userLoginService.User();
  selectedDiscussionId?: number;
  @ViewChild("masterModalContent", { static: false })
  masterModalContent!: ElementRef;
  masterModalRef!: NgbModalRef;

  @ViewChild("participantsModalContent", { static: false })
  participantsModalContent!: ElementRef;
  participantsModalRef!: NgbModalRef;

  @ViewChild("addMembersModalContent", { static: false })
  addMembersModalContent!: ElementRef;
  addMembersModalRef!: NgbModalRef;

  addMemberForm = new FormGroup({
    listType: new FormControl("staff", Validators.required),
    classId: new FormControl<number | null>(null),
    sectionId: new FormControl<number | null>(null),
  });

  addMemberSearchControl = new FormControl("");
  addMemberUserList: DiscussionUserDTO[] = [];
  selectedAddMemberIds: number[] = [];
  addMemberLoading = false;
  addingMembers = false;
  removingParticipantId: number | null = null;
  deletingGroup = false;
  addMemberShowClassSection = false;
  addMemberSectionList: SectionMasterDTO[] = [];
  addMemberLoadingSections = false;
  searchControl = new FormControl("");
  searchListControl = new FormControl("");
  masterTypeSelect = new FormControl("");
  newMessage = "";
  isSending = false;
  selectedDiscussion: DiscussionDTO | null = null;
  chatHeaderImage: string = "assets/SchoolModule/images/user.svg";
  chatTitle = "";
  chatSubtitle = "";

  assignedClassList: ClassMasterDTO[] = [];
  assignedSectionList: SectionMasterDTO[] = [];
  assignedStudents: StudentClassMappingDTO[] = [];
  teacherList: UserAffiliationMappingDTO[] = [];
  staffList: UserAffiliationMappingDTO[] = [];
  parentList: ParentStudentMappingDTO[] = [];
  User = inject(UserLoginService).User();

  filteredStaffList: any[] = []; // Filtered by type
  selectedStaffType: string = "";
  userAffiliationInfo: UserAffiliationMappingDTO | null = null;

  filterForm = new FormGroup({
    schoolId: new FormControl(0),
    listType: new FormControl("", Validators.required),
    classId: new FormControl<number | null>(null),
    sectionId: new FormControl<number | null>(null),
  });

  // async ngOnInit(): Promise<void> {
  //   try {
  //     if (!this.selectedSchoolId) {
  //       await this.loadUserAffiliationInfo(this.currentUserId);
  //     }

  //     this.initializeComponent();
  //     this.loadAffiliationData();
  //   } catch (error) {
  //     console.error(error);

  //     this.initializeComponent();
  //     this.loadAffiliationData();
  //   }
  // }

  async ngOnInit(): Promise<void> {
  try {
    if (!this.selectedSchoolId) {
      await this.loadUserAffiliationInfo(this.currentUserId);
    }

    this.initializeComponent();
    this.loadAffiliationData();
    this.setupAddMemberSubscriptions();

    this.filterForm.get('listType')?.valueChanges.subscribe(() => {
      const selectedType = String(
        this.filterForm.get('listType')?.value || ''
      ).toLowerCase();

      this.showClassSection =
        selectedType === 'student' || selectedType === 'parent';

      this.getDiscussionUserList(true);
    });

  } catch (error) {
    console.error(error);

    this.initializeComponent();
    this.loadAffiliationData();
    this.setupAddMemberSubscriptions();

    this.filterForm.get('listType')?.valueChanges.subscribe(() => {
      const selectedType = String(
        this.filterForm.get('listType')?.value || ''
      ).toLowerCase();

      this.showClassSection =
        selectedType === 'student' || selectedType === 'parent';

      this.getDiscussionUserList(true);
    });
  }
}

  ngOnDestroy(): void {
    this.isComponentDestroyed = true;
    this.stopMessageRefresh();
    this.stopVoiceToText();
    this.releaseMediaRecording();
    this.clearSelectedAttachment();

    if (this.wsSubscription) {
      this.wsSubscription.unsubscribe();
    }

    if (this.wsChatSubscription) {
      this.wsChatSubscription.unsubscribe();
    }

    this.webSocketService.close();
    this.chatListWebSocketService.close();
  }

  async loadUserAffiliationInfo(userId: number): Promise<void> {
    return new Promise((resolve, reject) => {
      const data: UserAffiliationMappingReadByUserIdRequestDTO = {
        userId,
      };

      this.schoolUserAffiliationMappingService
        .UserAffiliationMapping_ReadByUserId(data)
        .subscribe({
          next: (res) => {
            const userAffiliationInfo = res.items[0];

            if (userAffiliationInfo) {
              this.userAffiliationInfo = userAffiliationInfo;

              this.selectedSchoolId = userAffiliationInfo.schoolId;
              this.affiliationType = userAffiliationInfo.affiliationType;
              this.currentUserId = this.User.userId;
            }

            resolve();
          },
          error: (err) => {
            console.error(err);
            reject(err);
          },
        });
    });
  }

  private loadAffiliationData(): void {
    if (
      this.affiliationType === "School Admin" ||
      this.affiliationType === "SPE_School-Owner"
    ) {
      this.getClassListBySchoolId(this.selectedSchoolId);
    }

    if (
      this.affiliationType === "Parent" ||
      this.affiliationType === "Student"
    ) {
      this.getStudentClassMapping(this.studentId);
      this.classList = [];
      this.sectionList = [];
    }

    if (this.affiliationType === "Teaching Staff") {
      this.teacherId = this.currentUserId;
      this.getClassSubjMapping(this.teacherId);
    }

    this.applyFilterRules();
  }

  private initializeComponent(): void {
    this.setupSearch();

    this.messageSearchSubject
      .pipe(debounceTime(400))
      .subscribe((searchText) => {
        this.searchMessageText = searchText;
        this.performMessageSearch();
      });

    this.ReadAllPaginatedDTO.userId = this.currentUserId;

    this.wsChatSubscription = this.chatListWebSocketService
      .connect(
        this.ReadAllPaginatedDTO.userId,
        this.ReadAllPaginatedDTO.pageNo,
        this.ReadAllPaginatedDTO.pageSize,
      )
      .subscribe({
        next: (data) => {
          if (data && data.Items) {
            this.discussions = data.Items.map((incoming: any) => ({
              discussionId: incoming.DiscussionId,
              masterType: incoming.MasterType,
              displayName: incoming.DisplayName,
              displayImage: incoming.DisplayImage,
              totalParticipants: incoming.TotalParticipants,
              lastMessage: incoming.LastMessage,
              lastMessageTime: new Date(incoming.LastMessageTime),
              unreadCount: incoming.UnreadCount,
            }));
          }
        },
      });

    this.loadDiscussionsPaginated(this.ReadAllPaginatedDTO);

    this.searchListControl.valueChanges
      .pipe(debounceTime(400), distinctUntilChanged())
      .subscribe((term: string | null) => {
        const search = term?.trim() || "";

        let where = "";

        if (search) {
          where = search;
        }

        let type = this.filterForm.get("listType")?.value;
        let classId = this.filterForm.get("classId")?.value ?? null;
        let sectionId = this.filterForm.get("sectionId")?.value ?? null;

        if (
          this.affiliationType === "Parent" ||
          this.affiliationType === "Student"
        ) {
          type = "Teaching Staff";
          classId = this.currentStudentMapping?.classId!;
          sectionId = this.currentStudentMapping?.sectionId ?? null;
        }

        if (type) {
          this.getUserList(type, classId, sectionId, where);
        }
      });

    this.filterForm.get("listType")?.valueChanges.subscribe((type) => {
      if (!type) return;
      this.searchListControl.setValue("", { emitEvent: false });
      if (type === "student" || type === "parent") {
        this.userList = [];
        const classId = this.filterForm.get("classId")?.value;
        const sectionId = this.filterForm.get("sectionId")?.value ?? null;
        this.showClassSection = true;
        if (classId) {
          this.filterForm.patchValue({ sectionId: null }, { emitEvent: false });

          if (classId && !sectionId) {
            this.getUserList(type, classId);
          } else if (classId && sectionId) {
            this.getUserList(type, classId, sectionId);
          }
        }
      } else {
        this.showClassSection = false;

        this.filterForm.patchValue(
          {
            classId: null,
            sectionId: null,
          },
          { emitEvent: false },
        );

        this.getUserList(type!);
      }
    });

    this.filterForm.get("classId")?.valueChanges.subscribe((classId) => {
      const type = this.filterForm.get("listType")?.value;
      if (
        this.affiliationType === "Parent" ||
        this.affiliationType === "Student"
      ) {
        return;
      }
      if (classId) {
        if (
          this.affiliationType === "School Admin" ||
          this.affiliationType === "SPE_School-Owner"
        ) {
          this.fetchSectionsByClassId(classId);
        } else {
          this.getSectionsByClass(classId);
        }
      } else {
        this.sectionList = [];
        this.assignedStudents = [];

        this.filterForm.patchValue({ sectionId: null }, { emitEvent: false });
      }
    });

    this.filterForm.get("sectionId")?.valueChanges.subscribe((sectionId) => {
      const classId = this.filterForm.get("classId")?.value;
      const type = this.filterForm.get("listType")?.value;
      if (
        this.affiliationType === "Student" ||
        this.affiliationType === "Parent"
      ) {
        return;
      }

      if (classId && sectionId) {
        this.getUserList(type!, classId, sectionId);
      } else if (classId && !sectionId) {
        this.getUserList(type!, classId);
      }
    });
  }

  get staffColumn() {
    return this.filterForm.value.listType === "staff"
      ? "col-md-12"
      : "col-md-4";
  }
  onMessageSearchChange(value: string) {
    this.messageSearchSubject.next(value);
  }

  getClassListBySchoolId(schoolId: number) {
    this.classList = [];
    let data: ClassMasterReadBySchoolIdRequestDTO = {
      schoolId: schoolId,
      pageNo: 1,
      pageSize: 100,
    };
    this.classService.ClassMaster_ReadBySchoolId(data).subscribe({
      next: (res) => {
        this.classList = res.items;
      },
      error: (err) => {
        console.error("Error fetching class list:", err);
      },
    });
  }

  fetchSectionsByClassId(classId: number): void {
    this.loadingSections = true;
    this.sectionList = [];
    this.filterForm.patchValue({ sectionId: null });
    if (classId) {
      const request = { classId };
      this.sectionMasterService.SectionMaster_ReadByClassId(request).subscribe({
        next: (res) => {
          this.sectionList = res.items || [];
          if (this.sectionList.length > 0) {
            this.filterForm.patchValue({
              sectionId: this.sectionList[0].sectionId,
            });
          }
          this.loadingSections = false;
        },
        error: (err) => {
          this.sectionList = [];
          this.loadingSections = false;
        },
      });
    } else {
      this.sectionList = [];
      this.loadingSections = false;
    }
  }

  applyFilterRules() {
    if (
      this.affiliationType === "School Admin" ||
      this.affiliationType === "Teaching Staff" ||
      this.affiliationType === "SPE_School-Owner"
    ) {
      this.isSingleSelectMode = false;

      this.allowedListTypes = ["staff", "parent", "student"];
      this.filterForm.patchValue({ listType: "staff" }, { emitEvent: false });

      this.showListType = true;
      this.showClassSection = false;

      this.getUserList("staff");
    } else if (
      this.affiliationType === "Parent" ||
      this.affiliationType === "Student"
    ) {
      this.isSingleSelectMode = true;
      this.showListType = false;
      this.showClassSection = false;

      this.filterForm.patchValue(
        {
          classId: null,
          sectionId: null,
        },
        { emitEvent: false },
      );

      if (this.currentStudentMapping) {
        const classId = this.currentStudentMapping?.classId ?? null;
        const sectionId = this.currentStudentMapping?.sectionId ?? null;
        this.getUserList("Teaching Staff", classId, sectionId);
      }
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      this.selectedSchoolId > 0 &&
      this.affiliationType &&
      this.currentUserId
    ) {
      this.ReadAllPaginatedDTO.userId = this.currentUserId;

      // LOAD DISCUSSIONS
      this.loadDiscussionsPaginated(this.ReadAllPaginatedDTO);

      // SOCKET
      if (!this.wsChatSubscription) {
        this.wsChatSubscription = this.chatListWebSocketService
          .connect(
            this.ReadAllPaginatedDTO.userId,
            this.ReadAllPaginatedDTO.pageNo,
            this.ReadAllPaginatedDTO.pageSize,
          )
          .subscribe({
            next: (data) => {
              if (data && data.Items) {
                this.discussions = data.Items.map((incoming: any) => ({
                  discussionId: incoming.DiscussionId,
                  masterType: incoming.MasterType,
                  displayName: incoming.DisplayName,
                  displayImage: incoming.DisplayImage,
                  totalParticipants: incoming.TotalParticipants,
                  lastMessage: incoming.LastMessage,
                  lastMessageTime: new Date(incoming.LastMessageTime),
                  unreadCount: incoming.UnreadCount,
                }));
              }
            },
          });
      }

      // ROLE LOGIC
      if (
        this.affiliationType === "School Admin" ||
        this.affiliationType === "SPE_School-Owner" ||
        this.affiliationType.toLowerCase() === "owner"
      ) {
        this.getClassListBySchoolId(this.selectedSchoolId);
      }

      if (
        this.affiliationType === "Parent" ||
        this.affiliationType === "Student"
      ) {
        this.getStudentClassMapping(this.studentId);
        this.classList = [];
        this.sectionList = [];
      }

      if (this.affiliationType === "Teaching Staff") {
        this.teacherId = this.currentUserId;
        this.getClassSubjMapping(this.teacherId);
      }

      // APPLY FILTERS
      this.applyFilterRules();
    }
  }

  getStudentClassMapping(userId: number) {
    this.isStudentMappingLoading = false;
    let data: StudentClassMappingReadByUserIdRequestDTO = { userId };

    this.studentClassMappingService
      .StudentClassMapping_ReadByUserId(data)
      .subscribe({
        next: (res) => {
          const mapping = res.items.find(
            (m: any) => m.schoolId === this.selectedSchoolId,
          );

          if (!mapping) {
            this.isStudentMappingLoading = false;
            return;
          }

          const classId = mapping.classId;
          const sectionId = mapping.sectionId ?? null;
          this.currentStudentMapping = { classId, sectionId };
          this.filterForm.patchValue({
            classId: classId,
            sectionId: sectionId,
          });

          this.getUserList("Teaching Staff", classId, sectionId);
          this.isStudentMappingLoading = false;
        },
        error: () => {
          this.toastr.error("Error fetching class mapping");
          this.isStudentMappingLoading = false;
        },
      });
  }

  getUserList(
    listType: string,
    classId?: number | null,
    sectionId?: number | null,
    whereClause?: string,
  ) {
    if (!this.isUserFetchingMore) {
      this.userListLoading = true;
      this.dontShowSelect = false;
      this.userList = [];
      this.selectedCount = 0;
      this.selectedUserIds = [];
      this.hasMoreUsers = true;
    }

    let payload: DiscussionMasterGetDiscussionUserListRequestDTO = {
      schoolId: this.selectedSchoolId,
      listType: listType,
      classId: classId ?? null,
      sectionId: sectionId ?? null,
      pageSize: this.userPageSize,
      pageNo: 1,
      orderByClause: "FirstName",
      whereClause: (whereClause || "").trim(),
    };
    this.discussionMasterService
      .DiscussionMaster_GetDiscussionUserList(payload)
      .subscribe({
        next: (res) => {
          if (res.items.length === 0) {
            this.dontShowSelect = true;
          }

          const mappedUsers = res.items.map((u) => ({
            ...u,
            selected: this.selectedUserIds.includes(u.userId),
            profileImage: u.profileImage?.trim()
              ? u.profileImage
              : "assets/SchoolModule/images/user.svg",
          }));

          // ✅ APPEND ON SCROLL
          if (this.isUserFetchingMore) {
            const existingIds = new Set(this.userList.map((u) => u.userId));
            const uniqueNewUsers = mappedUsers.filter(
              (u) => !existingIds.has(u.userId),
            );

            if (uniqueNewUsers.length === 0) {
              this.hasMoreUsers = false; // 🔒 STOP SCROLL
            } else {
              this.userList = [...this.userList, ...uniqueNewUsers];
            }
          } else {
            this.userList = mappedUsers;
          }

          this.userListLoading = false;
          this.isUserFetchingMore = false;
        },
        error: (err) => {
          this.userListLoading = false;
        },
      });
  }
  getClassSubjMapping(teacherId: number) {
    this.classList = [];
    this.sectionList = [];
    this.assignedStudents = [];
    this.noClassAssigned = false;
    this.isClassLoading = true;
    this.teacherClassSubjectMapping
      .TeacherClassSubjectMapping_ReadByTeacherId({ teacherId })
      .subscribe({
        next: (res) => {
          this.teacherClassSubjectList = res.items;

          this.isClassLoading = false;

          if (!this.teacherClassSubjectList.length) {
            this.noClassAssigned = true;
            this.classList = [];
            this.sectionList = [];
            this.assignedStudents = [];
            this.toastr.warning("the class and section not assigned ");
            return;
          }
          this.classList = this.teacherClassSubjectList
            .map(
              (x) =>
                ({
                  classId: x.classId,
                  className: x.className,
                }) as ClassMasterDTO,
            )
            .filter(
              (v, i, arr) =>
                i === arr.findIndex((t) => t.classId === v.classId),
            );

          if (this.classList.length && !this.searchClassId) {
            const firstClass = this.classList[0];
            this.searchClassId = firstClass.classId;

            this.getSectionsByClass(this.searchClassId, true);
          }

          const currentType = this.filterForm.get("listType")?.value;
          if (currentType === "staff") {
            this.isClassLoading = true;
            this.getUserList("staff");
          }
          this.isClassLoading = false;
        },
        error: (err) => {
          this.isClassLoading = false;
        },
      });
  }

  getSectionsByClass(classId: number, selectFirst: boolean = false) {
    const classMappings = this.teacherClassSubjectList.filter(
      (x) => x.classId === classId,
    );

    this.sectionList = classMappings
      .filter((x) => x.sectionId)
      .map(
        (x) =>
          ({
            sectionId: x.sectionId,
            sectionName: x.sectionName,
          }) as SectionMasterDTO,
      )
      .filter(
        (v, i, arr) => i === arr.findIndex((t) => t.sectionId === v.sectionId),
      );

    this.searchSectionId = null;
    if (this.sectionList.length > 0) {
      if (selectFirst) {
        const firstSection = this.sectionList[0];
        this.searchSectionId = firstSection.sectionId;
        this.filterForm.patchValue(
          {
            sectionId: this.searchSectionId,
          },
          { emitEvent: false },
        );
      }

      this.searchSectionId = this.sectionList[0].sectionId;
      this.filterForm.patchValue(
        {
          sectionId: this.searchSectionId,
        },
        { emitEvent: true },
      );
    } else {
      this.filterForm.patchValue(
        {
          sectionId: null,
        },
        { emitEvent: true },
      );
      this.searchSectionId = null;
    }
  }

  onDiscussionSelected(discussion: DiscussionDTO) {
    this.closeSearch();
    if (this.previousDiscussionId === discussion.discussionId) {
      return;
    }

    if (this.wsSubscription) {
      this.wsSubscription.unsubscribe();
      this.webSocketService.close();
    }

    this.previousDiscussionId = discussion.discussionId;
    this.stopMessageRefresh();
    this.currentLoadToken++;
    this.refreshInFlight = false;
    this.stopVoiceToText();
    this.releaseMediaRecording();
    this.clearSelectedAttachment();
    this.showEmojiPicker = false;

    this.lastMarkedReadDetailId = null;

    this.selectedDiscussion = discussion;
    this.selectedDiscussionId = discussion.discussionId;

    this.hasMoreOldMessages = true;
    this.lastDetailId = null;

    this.isGroupChat = discussion.masterType === "Group";

    this.chatTitle =
      discussion.displayName ||
      (this.isGroupChat ? "Group Chat" : "Private Chat");
    this.chatSubtitle = "";

    const img = discussion?.displayImage?.trim();
    this.chatHeaderImage = img
      ? img
      : this.isGroupChat
        ? "assets/SchoolModule/images/group.svg"
        : "assets/SchoolModule/images/user.svg";
    if (this.selectedDiscussionId) {
      this.discussionDetails = [];
      this.groupedMessages = [];
      this.isChatLoading = false; // ✅ Reset here
      this.isMsgGrouping = false;
    }
    this.loadMessages();

    if (this.isGroupChat) {
      this.loadParticipants();
    }

    this.subscribeToDiscussionMessages(this.selectedDiscussionId);
    this.startMessageRefresh();
  }


  // FIX: Handle both SignalR message deltas and full snapshots. An empty
  // event must never wipe the current chat (the old handler did that).
  private subscribeToDiscussionMessages(discussionId: number): void {
    this.wsSubscription = this.webSocketService.connect(discussionId).subscribe({
      next: (data: any) => {
        if (!data || this.selectedDiscussionId !== discussionId) return;
        const eventType = String(data.eventType ?? data.EventType ?? data.type ?? data.Type ?? "").toLowerCase();
        const rawItems = data.Items ?? data.items;
        const entries = Array.isArray(rawItems)
          ? rawItems
          : (data.DetailId || data.detailId ? [data] : []);
        let changed = false;
        let hasNewMessage = false;

        if (eventType.includes("delete") && (data.detailId || data.DetailId)) {
          this.applyDeletedMessage(Number(data.detailId ?? data.DetailId));
          changed = true;
        }

        for (const raw of entries) {
          const message = this.normalizeDiscussionMessage(raw);
          const id = Number(message.detailId || 0);
          if (!id || Number(message.discussionId || discussionId) !== discussionId) continue;
          if (this.isMessageDeleted(message)) {
            this.applyDeletedMessage(id);
            changed = true;
            continue;
          }
          const existing = this.discussionDetails.find(m => Number(m.detailId) === id);
          if (existing) {
            // An edit can arrive with the same id; the old implementation discarded it.
            if (!this.isMessageDeleted(existing)) {
              const updated = existing.discDesc !== message.discDesc ||
                existing.isDeleted !== message.isDeleted ||
                existing.otherDetail1 !== message.otherDetail1 ||
                existing.otherDetail4 !== message.otherDetail4;
              if (updated) {
                Object.assign(existing, { ...message });
                changed = true;
              }
            }
          } else {
            this.discussionDetails.push(message);
            changed = true;
            hasNewMessage = true;
          }
        }

        if (changed) {
          this.discussionDetails.sort((a, b) =>
            +new Date(a.createdOn || 0) - +new Date(b.createdOn || 0)
          );
          this.groupMessagesByDate(this.discussionDetails);
          if (hasNewMessage) {
            setTimeout(() => {
              if (this.selectedDiscussionId === discussionId) {
                this.scrollToBottom();
                this.markAsRead();
              }
            }, 100);
          }
        }
        // The backend may broadcast only new messages, so also reconcile
        // edits/deletions against an authoritative paginated read.
        this.refreshVisibleMessages();
      },
      error: (err: any) => console.error("Discussion realtime connection failed", err),
    });
  }

  private normalizeDiscussionMessage(item: any): DiscussionDetailDTO {
    return {
      ...item,
      detailId: item.detailId ?? item.DetailId,
      discussionId: item.discussionId ?? item.DiscussionId,
      postedBy: item.postedBy ?? item.PostedBy,
      postedAt: item.postedAt ?? item.PostedAt,
      discDesc: item.discDesc ?? item.DiscDesc ?? "",
      otherDetail1: item.otherDetail1 ?? item.OtherDetail1 ?? "",
      otherDetail2: item.otherDetail2 ?? item.OtherDetail2 ?? "",
      otherDetail3: item.otherDetail3 ?? item.OtherDetail3 ?? "",
      otherDetail4: item.otherDetail4 ?? item.OtherDetail4 ?? "",
      otherDetail5: item.otherDetail5 ?? item.OtherDetail5 ?? "",
      otherDetail6: item.otherDetail6 ?? item.OtherDetail6 ?? "",
      isActive: item.isActive ?? item.IsActive,
      isDeleted: item.isDeleted ?? item.IsDeleted,
      createdBy: item.createdBy ?? item.CreatedBy,
      createdOn: item.createdOn ?? item.CreatedOn,
      modifiedBy: item.modifiedBy ?? item.ModifiedBy,
      modifiedOn: item.modifiedOn ?? item.ModifiedOn,
      userName: item.userName ?? item.UserName,
    } as DiscussionDetailDTO;
  }

  private startMessageRefresh(): void {
    this.stopMessageRefresh();
    this.refreshInterval = setInterval(() => this.refreshVisibleMessages(), 4000);
  }

  private stopMessageRefresh(): void {
    if (this.refreshInterval) {
      clearInterval(this.refreshInterval);
      this.refreshInterval = null;
    }
  }

  private refreshVisibleMessages(): void {
    const discussionId = this.selectedDiscussionId;
    if (!discussionId || this.refreshInFlight || this.isComponentDestroyed) return;
    this.refreshInFlight = true;
    const readPageSize = Math.max(this.pageSize, 100);

    this.discussionDetailService.DiscussionDetail_ReadByDiscussionId({
      discussionId,
      lastDetailId: null,
      pageSize: readPageSize,
    }).subscribe({
      next: (res: DiscussionDetailList) => {
        this.refreshInFlight = false;
        if (this.selectedDiscussionId !== discussionId || this.isComponentDestroyed) return;
        const remote = (res.items ?? []).map(i => this.normalizeDiscussionMessage(i));
        const knownRemoteIds = new Set(remote.map(m => Number(m.detailId)));
        const lowestReturnedId = remote.length > 0
          ? Math.min(...remote.map(m => Number(m.detailId)))
          : 0;
        let changed = false;
        let hasNew = false;

        // The read API can omit deleted rows. Only mark a local message as
        // deleted when its id lies inside the fetched latest-page coverage.
        // Never interpret an older paginated message as missing/deleted.
        for (const local of this.discussionDetails) {
          const id = Number(local.detailId || 0);
          const inCoveredPage = remote.length === 0 || id >= lowestReturnedId;
          if (id > 0 && inCoveredPage && !knownRemoteIds.has(id) && !this.isMessageDeleted(local)) {
            this.localDeletedMessageIds.add(id);
            local.isDeleted = 1;
            local.discDesc = "";
            changed = true;
          }
        }

        for (const item of remote) {
          const id = Number(item.detailId || 0);
          if (!id) continue;
          if (this.isMessageDeleted(item)) {
            this.localDeletedMessageIds.add(id);
          }
          const existing = this.discussionDetails.find(m => Number(m.detailId) === id);
          if (!existing) {
            this.discussionDetails.push(item);
            changed = true;
            hasNew = true;
          } else if (!this.isMessageDeleted(existing)) {
            if (existing.discDesc !== item.discDesc ||
                existing.isDeleted !== item.isDeleted ||
                existing.otherDetail1 !== item.otherDetail1) {
              Object.assign(existing, item);
              changed = true;
            }
          }
        }

        if (changed) {
          this.discussionDetails.sort((a, b) =>
            +new Date(a.createdOn || 0) - +new Date(b.createdOn || 0)
          );
          this.groupMessagesByDate(this.discussionDetails);
          if (hasNew) {
            setTimeout(() => {
              if (this.selectedDiscussionId === discussionId) this.markAsRead();
            }, 100);
          }
        }
      },
      error: () => { this.refreshInFlight = false; },
    });
  }

  private applyDeletedMessage(detailId: number): void {
    if (!detailId) return;
    this.localDeletedMessageIds.add(detailId);
    const message = this.discussionDetails.find(m => Number(m.detailId) === detailId);
    if (message) {
      message.isDeleted = 1;
      message.discDesc = "";
      message.otherDetail1 = "";
      message.otherDetail2 = "";
      message.otherDetail3 = "";
      this.groupMessagesByDate(this.discussionDetails);
    }
  }

  isMessageDeleted(msg: DiscussionDetailDTO): boolean {
    return Number(msg?.isDeleted || 0) === 1 ||
      this.localDeletedMessageIds.has(Number(msg?.detailId || 0));
  }

  // The server must return an HTTPS URL or a same-origin path.
  private isSafeAttachmentUrl(value: string): boolean {
    if (!value) return false;
    if (value.startsWith("/") && !value.startsWith("//")) return true;
    try {
      return new URL(value).protocol === "https:";
    } catch {
      return false;
    }
  }

  getMessageAttachmentUrl(msg: DiscussionDetailDTO): string | null {
    if (this.isMessageDeleted(msg)) return null;
    const isOldAttachment = String(msg?.otherDetail4 || "") === "NISHWIK_CHAT_ATTACHMENT_V1";
    const isNewAttachment = String(msg?.otherDetail1 || "").toUpperCase() === "ATTACHMENT";
    if (!isOldAttachment && !isNewAttachment) return null;
    const value = String(isNewAttachment ? msg?.otherDetail5 : msg?.otherDetail1 || "").trim();
    return this.isSafeAttachmentUrl(value) ? value : null;
  }

  getMessageAttachmentName(msg: DiscussionDetailDTO): string {
    return String(String(msg?.otherDetail1 || "").toUpperCase() === "ATTACHMENT"
      ? (msg?.otherDetail6 || "Attachment")
      : (msg?.otherDetail2 || "Attachment"));
  }

  isAudioMessage(msg: DiscussionDetailDTO): boolean {
    if (!this.getMessageAttachmentUrl(msg)) return false;
    const type = String(msg?.otherDetail2 || "").toLowerCase();
    return type === "audio" || String(msg?.otherDetail3 || "").toLowerCase().startsWith("audio/");
  }

  isImageMessage(msg: DiscussionDetailDTO): boolean {
    if (!this.getMessageAttachmentUrl(msg)) return false;
    const type = String(msg?.otherDetail2 || "").toLowerCase();
    return type === "image" || /^(image\/png|image\/jpeg|image\/webp|image\/gif)$/i.test(String(msg?.otherDetail3 || ""));
  }

  openAttachmentPicker(): void {
    if (!this.selectedDiscussionId || this.isSubmitting || this.isRecording) return;
    this.attachmentFileInput?.nativeElement.click();
  }

  onAttachmentSelected(event: Event): void {
    const target = event.target as HTMLInputElement;
    const file = target.files?.[0];
    if (!file) return;
    if (file.size > this.maxAttachmentBytes || file.size === 0) {
      this.toastr.error("Attachment must be between 1 byte and 10 MB.");
      target.value = "";
      return;
    }
    const allowedTypes = new Set([
      "image/png", "image/jpeg", "image/webp", "image/gif", "application/pdf",
      "text/plain", "application/msword", "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "application/vnd.ms-excel", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "audio/webm", "audio/ogg", "audio/mp4", "audio/mpeg", "audio/wav", "audio/x-wav",
    ]);
    if (!allowedTypes.has(file.type.toLowerCase())) {
      this.toastr.error("Unsupported file type.");
      target.value = "";
      return;
    }
    this.setSelectedAttachment(file);
  }

  private setSelectedAttachment(file: File): void {
    this.clearSelectedAttachment();
    this.selectedAttachment = file;
    if (file.type.startsWith("audio/") || file.type.startsWith("image/")) {
      this.selectedAttachmentPreviewUrl = URL.createObjectURL(file);
    }
  }

  clearSelectedAttachment(): void {
    if (this.selectedAttachmentPreviewUrl) {
      URL.revokeObjectURL(this.selectedAttachmentPreviewUrl);
      this.selectedAttachmentPreviewUrl = null;
    }
    this.selectedAttachment = null;
    if (this.attachmentFileInput) this.attachmentFileInput.nativeElement.value = "";
  }

  toggleEmojiPicker(): void {
    this.showEmojiPicker = !this.showEmojiPicker;
  }

  insertEmoji(emoji: string): void {
    const input = this.messageComposer?.nativeElement;
    const cursorStart = input?.selectionStart ?? this.newMessage.length;
    const cursorEnd = input?.selectionEnd ?? this.newMessage.length;
    this.newMessage =
      this.newMessage.slice(0, cursorStart) + emoji + this.newMessage.slice(cursorEnd);
    this.showEmojiPicker = false;
    setTimeout(() => {
      if (input) {
        input.focus();
        input.setSelectionRange(cursorStart + emoji.length, cursorStart + emoji.length);
      }
    });
  }

  // Browser SpeechRecognition converts speech directly into the existing
  // message composer. It does not upload speech or auto-send messages.
  startVoiceToText(): void {
    if (this.isRecording) return;
    if (this.isVoiceToTextListening) {
      this.stopVoiceToText();
      return;
    }
    const recognitionClass = (window as any).SpeechRecognition || (window as any).webkitSpeechRecognition;
    if (!recognitionClass) {
      this.toastr.warning("Voice-to-text is unavailable in this browser. Try Chrome or Edge.");
      return;
    }

    this.dictationBaseText = this.newMessage;
    const recognition = new recognitionClass();
    this.speechRecognition = recognition;
    recognition.continuous = true;
    recognition.interimResults = true;
    recognition.lang = "en-US";
    recognition.onresult = (event: any) => {
      let finalText = "";
      let interimText = "";
      for (let i = 0; i < event.results.length; i++) {
        const phrase = event.results[i][0].transcript;
        if (event.results[i].isFinal) finalText += phrase + " ";
        else interimText += phrase;
      }
      this.newMessage = this.dictationBaseText +
        (this.dictationBaseText && !this.dictationBaseText.endsWith(" ") ? " " : "") +
        finalText + interimText;
    };
    recognition.onerror = (event: any) => {
      this.isVoiceToTextListening = false;
      this.voiceStatus = "Speech recognition error: " + (event?.error || "unknown");
    };
    recognition.onend = () => {
      this.isVoiceToTextListening = false;
      this.voiceStatus = "Voice-to-text stopped";
    };
    try {
      recognition.start();
      this.isVoiceToTextListening = true;
      this.voiceStatus = "Listening... Speak now";
    } catch (err) {
      this.isVoiceToTextListening = false;
      console.error("Speech recognition start failed", err);
      this.toastr.error("Could not start voice-to-text.");
    }
  }

  stopVoiceToText(): void {
    if (this.speechRecognition) {
      try { this.speechRecognition.stop(); } catch { /* already stopped */ }
      this.speechRecognition = null;
    }
    this.isVoiceToTextListening = false;
  }

  async startVoiceRecording(): Promise<void> {
    if (!this.selectedDiscussionId || this.isRecording || this.isSubmitting) return;
    this.stopVoiceToText();
    if (!navigator.mediaDevices?.getUserMedia || typeof MediaRecorder === "undefined") {
      this.toastr.warning("Audio recording is not available in this browser.");
      return;
    }
    const requestedDiscussionId = this.selectedDiscussionId;
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      if (this.isComponentDestroyed || this.selectedDiscussionId !== requestedDiscussionId) {
        stream.getTracks().forEach(track => track.stop());
        return;
      }
      this.recordingStream = stream;
      const mime = ["audio/webm;codecs=opus", "audio/webm", "audio/mp4", "audio/ogg"]
        .find(type => MediaRecorder.isTypeSupported(type));
      const recorder = mime ? new MediaRecorder(stream, { mimeType: mime }) : new MediaRecorder(stream);
      this.recorder = recorder;
      this.recordedChunks = [];
      recorder.ondataavailable = event => {
        if (event.data.size > 0) this.recordedChunks.push(event.data);
      };
      recorder.onstop = () => {
        const mimeType = recorder.mimeType.split(";")[0] || "audio/webm";
        const blob = new Blob(this.recordedChunks, { type: mimeType });
        this.releaseRecordingStream();
        this.isRecording = false;
        if (blob.size === 0) {
          this.toastr.warning("No audio was recorded.");
          return;
        }
        if (blob.size > this.maxAttachmentBytes) {
          this.toastr.error("Voice recording exceeds 10 MB.");
          return;
        }
        const extension = mimeType.includes("mp4") ? "m4a" : mimeType.includes("ogg") ? "ogg" : "webm";
        this.setSelectedAttachment(new File([blob], `voice-${Date.now()}.${extension}`, { type: mimeType }));
      };
      recorder.onerror = (event: any) => {
        console.error("Audio recording failed", event);
        this.toastr.error("Voice recording failed.");
        this.releaseMediaRecording();
      };
      recorder.start(500);
      this.isRecording = true;
      this.voiceStatus = "Recording voice message...";
    } catch (err) {
      console.error("Microphone permission error", err);
      this.releaseMediaRecording();
      this.toastr.error("Microphone permission denied or unavailable.");
    }
  }

  stopVoiceRecording(): void {
    if (this.recorder && this.recorder.state !== "inactive") {
      this.recorder.stop();
      this.voiceStatus = "Voice message recorded";
    }
  }

  private releaseRecordingStream(): void {
    this.recordingStream?.getTracks().forEach(track => track.stop());
    this.recordingStream = null;
  }

  private releaseMediaRecording(): void {
    if (this.recorder) {
      this.recorder.onstop = null;
      if (this.recorder.state !== "inactive") this.recorder.stop();
      this.recorder = null;
    }
    this.releaseRecordingStream();
    this.isRecording = false;
  }

  getDiscussionIcon(d: any) {
    const img = d.displayImage?.trim();

    if (img) return img;

    // Default fallback
    if (d.masterType === "Group") {
      return "assets/SchoolModule/images/group.svg";
    }

    return "assets/SchoolModule/images/user.svg";
  }

  ReadAllPaginatedDTO = {
    userId: 0,
    pageNo: 1,
    pageSize: 15,
    whereClause: "",
    orderByClause: "",
  };

  setupSearch() {
    this.searchControl.valueChanges
      .pipe(debounceTime(400), distinctUntilChanged())
      .subscribe((term: string | null) => {
        const search = term?.trim() || "";

        let where = "";

        if (search) {
          where = search;
        }

        this.ReadAllPaginatedDTO = {
          ...this.ReadAllPaginatedDTO,
          userId: this.currentUserId!,
          whereClause: where,
        };

        this.loadDiscussionsPaginated(this.ReadAllPaginatedDTO);
      });
  }

  loadDiscussionsPaginated(
    data: DiscussionMasterReadByUserIdRequestDTO,
    isAppend: boolean = false,
  ) {
    this.discussionLoading = true;
    data = {
      ...data,
      userId: this.currentUserId!,
    };
    this.discussionMasterService
      .DiscussionMaster_GetDiscussionList(data)
      .subscribe({
        next: (res) => {
          const incomingItems = res.items ?? [];

          // --- PAGINATION LOGIC START ---
          if (isAppend) {
            // Filter to ensure no duplicates, then append to the existing list
            const existingIds = new Set(
              this.discussions.map((d) => d.discussionId),
            );
            const uniqueNewItems = incomingItems.filter(
              (item) => !existingIds.has(item.discussionId),
            );
            this.discussions = [...this.discussions, ...uniqueNewItems];

            this.updateChatListWebSocket();
          } else {
            // Fresh load (Page 1 or Search)
            this.discussions = incomingItems;
          }

          // Update "hasMore" flag based on if we received a full page
          this.hasMoreDiscussions = incomingItems.length === data.pageSize;
          this.discussionLoading = false;
          this.isFetchingMore = false;

          if (!this.selectedDiscussionId && this.discussions.length > 0) {
            this.selectedDiscussionId = this.discussions[0].discussionId;
            this.selectedDiscussion = this.discussions[0];

            this.isGroupChat = this.discussions[0].masterType === "Group";
            this.setChatHeader(this.discussions[0]);
            this.loadMessages();
            if (this.isGroupChat) {
              this.loadParticipants();
            }
            if (this.wsSubscription) {
              this.wsSubscription.unsubscribe();
              this.webSocketService.close();
            }
            this.subscribeToDiscussionMessages(this.selectedDiscussionId);
            this.startMessageRefresh();
          }
        },
        error: (err) => {
          this.discussionLoading = false;
        },
      });
  }

  updateChatListWebSocket(priorityDiscussionId?: number) {
    if (this.wsChatSubscription) {
      this.wsChatSubscription.unsubscribe();
    }

    this.wsChatSubscription = this.chatListWebSocketService
      .connect(
        this.ReadAllPaginatedDTO.userId,
        1,
        this.ReadAllPaginatedDTO.pageSize,
      )
      .subscribe({
        next: (data) => {
          if (data && data.Items) {
            const mappedDiscussions = data.Items.map((incoming: any) => ({
              discussionId: incoming.DiscussionId,
              masterType: incoming.MasterType,
              displayName: incoming.DisplayName,
              displayImage: incoming.DisplayImage,
              totalParticipants: incoming.TotalParticipants,
              lastMessage: incoming.LastMessage,
              lastMessageTime: new Date(incoming.LastMessageTime),
              unreadCount: incoming.UnreadCount,
            }));

            const keepOnTopId =
              priorityDiscussionId || this.selectedDiscussionId;

            const priorityDiscussion = mappedDiscussions.find(
              (discussion: DiscussionListingDTO) =>
                discussion.discussionId === keepOnTopId,
            );

            this.discussions = priorityDiscussion
              ? [
                  priorityDiscussion,
                  ...mappedDiscussions.filter(
                    (discussion: DiscussionListingDTO) =>
                      discussion.discussionId !== keepOnTopId,
                  ),
                ]
              : mappedDiscussions;
          }
        },
      });
  }

  onKeyDown(event: KeyboardEvent): void {
    if (event.key === "Enter" && !event.shiftKey) {
      event.preventDefault();
      this.sendMessage();
    }
  }

  // openCreateModal(): void {
  //   this.userList = [];
  //   this.isPanelOpen = !this.isPanelOpen;

  //   this.searchListControl.reset("", { emitEvent: false });

  //   this.filterForm.reset(
  //     { schoolId: this.selectedSchoolId, classId: null, sectionId: null },
  //     { emitEvent: false },
  //   );

  //   this.applyFilterRules();
  // }

  openCreateModal(): void {
  this.isPanelOpen = true;
  this.isGroupMode = false;
  this.isSingleSelectMode = false;

  this.userList = [];
  this.selectedUserIds = [];
  this.selectedCount = 0;
  this.userPageSize = 10;
  this.hasMoreUsers = true;
  this.isUserFetchingMore = false;

  this.configureCreateChatPanel();

  const defaultType = this.allowedListTypes?.[0] || 'staff';

  this.filterForm.patchValue(
    {
      listType: defaultType,
      classId: null,
      sectionId: null
    },
    { emitEvent: false }
  );

  this.getDiscussionUserList(true);
}

configureCreateChatPanel(): void {
  const roleIds: number[] = String(this.user?.roleId || '')
    .split(',')
    .map((x: string) => Number(x.trim()))
    .filter((x: number) => !isNaN(x));

  const affiliation = String(this.affiliationType || '').toLowerCase();

  const isSchoolAdmin =
    roleIds.includes(5) ||
    roleIds.includes(25) ||
    affiliation.includes('school admin') ||
    affiliation.includes('school-owner') ||
    affiliation.includes('spe_school-owner');

  const isTeachingStaff =
    roleIds.includes(17) ||
    affiliation.includes('teaching staff') ||
    affiliation.includes('teacher');

  const isNonTeachingStaff =
    roleIds.includes(18) ||
    affiliation.includes('nonteaching') ||
    affiliation.includes('non-teaching') ||
    affiliation.includes('non teaching');

  const isDriver = affiliation.includes('driver');

  const isParent =
    roleIds.includes(6) ||
    affiliation.includes('parent');

  const isStudent =
    roleIds.includes(19) ||
    affiliation.includes('student');

  this.showListType = true;
  this.showClassSection = false;

  /*
    FIX:
    Earlier Teaching Staff was restricted to ['staff'] inside this function.
    Because openCreateModal() calls configureCreateChatPanel(), the dropdown showed
    only Staff even though applyFilterRules() already allowed staff / parent / student.

    Keep existing flow, only correct the allowed list for teacher login.
  */
  if (isSchoolAdmin) {
    this.allowedListTypes = ['staff', 'student', 'parent', 'driver'];
    return;
  }

  if (isTeachingStaff) {
    this.allowedListTypes = ['staff', 'student', 'parent'];
    return;
  }

  if (isNonTeachingStaff || isDriver) {
    this.allowedListTypes = ['staff'];
    return;
  }

  if (isParent || isStudent) {
    this.allowedListTypes = ['staff'];
    return;
  }

  this.allowedListTypes = ['staff'];
}

getDiscussionUserList(reset: boolean = false): void {
  if (!this.selectedSchoolId) {
    this.toastr.warning('School not found.');
    return;
  }

  if (reset) {
    this.userList = [];
    this.userPageSize = 10;
    this.hasMoreUsers = true;
    this.isUserFetchingMore = false;
  }

  const listType = String(
    this.filterForm.get('listType')?.value || 'staff'
  ).toLowerCase();

  const payload: DiscussionMasterGetDiscussionUserListRequestDTO = {
    schoolId: Number(this.selectedSchoolId),
    listType: listType,
    classId: Number(this.filterForm.get('classId')?.value || 0),
    sectionId: Number(this.filterForm.get('sectionId')?.value || 0),
    pageNo: 1,
    pageSize: this.userPageSize
  };

  this.userListLoading = true;

  this.discussionMasterService
    .DiscussionMaster_GetDiscussionUserList(payload)
    .subscribe({
      next: (res: any) => {
        const data = res?.items || res || [];

        const loggedInUserId = Number(
          this.user?.userId || this.currentUserId || 0
        );

        const searchText = String(
          this.searchListControl?.value || ''
        ).toLowerCase();

        this.userList = data
          .filter((x: any) => Number(x.userId) !== loggedInUserId)
          .filter((x: any) => {
            if (!searchText) {
              return true;
            }

            return String(x.userName || '')
              .toLowerCase()
              .includes(searchText);
          })
          .map((x: any) => ({
            ...x,
            selected: this.selectedUserIds.includes(Number(x.userId)),
            profileImage:
              x.profileImage || 'assets/SchoolModule/images/user.svg'
          }));

        this.hasMoreUsers = data.length >= this.userPageSize;
        this.userListLoading = false;
      },
      error: () => {
        this.userList = [];
        this.userListLoading = false;
      }
    });
}

  chats = [
    {
      id: 1,
      name: "Anurag Mishra",
      profile: "https://cdn-icons-png.flaticon.com/512/3135/3135715.png",
      selected: false,
    },
    {
      id: 2,
      name: "Rohan Mehta",
      profile: "https://cdn-icons-png.flaticon.com/512/3135/3135715.png",
      selected: false,
    },
    {
      id: 3,
      name: "Anurag Mishra",
      profile: "https://cdn-icons-png.flaticon.com/512/3135/3135715.png",
      selected: false,
    },
    {
      id: 4,
      name: "Rohan Mehta",
      profile: "https://cdn-icons-png.flaticon.com/512/3135/3135715.png",
      selected: false,
    },
    {
      id: 1,
      name: "Anurag Mishra",
      profile: "https://cdn-icons-png.flaticon.com/512/3135/3135715.png",
      selected: false,
    },
    {
      id: 2,
      name: "Rohan Mehta",
      profile: "https://cdn-icons-png.flaticon.com/512/3135/3135715.png",
      selected: false,
    },
    {
      id: 3,
      name: "Anurag Mishra",
      profile: "https://cdn-icons-png.flaticon.com/512/3135/3135715.png",
      selected: false,
    },
    {
      id: 4,
      name: "Rohan Mehta",
      profile: "https://cdn-icons-png.flaticon.com/512/3135/3135715.png",
      selected: false,
    },
    {
      id: 1,
      name: "Anurag Mishra",
      profile: "https://cdn-icons-png.flaticon.com/512/3135/3135715.png",
      selected: false,
    },
    {
      id: 2,
      name: "Rohan Mehta",
      profile: "https://cdn-icons-png.flaticon.com/512/3135/3135715.png",
      selected: false,
    },
    {
      id: 3,
      name: "Anurag Mishra",
      profile: "https://cdn-icons-png.flaticon.com/512/3135/3135715.png",
      selected: false,
    },
    {
      id: 4,
      name: "Rohan Mehta",
      profile: "https://cdn-icons-png.flaticon.com/512/3135/3135715.png",
      selected: false,
    },
  ];

  isGroupMode: boolean = false;

  enterGroupMode() {
    this.isGroupMode = true;
    this.discussionForm.reset();
    this.discussionForm.patchValue({
      canMembersPost: true,
    });
  }

  exitGroupMode() {
    this.isGroupMode = false;
    this.chats.forEach((c) => (c.selected = false));
  }

  openEditModal(): void {
    if (!this.selectedDiscussion && !this.isGroupChat) return;

    const d = this.selectedDiscussion!;
    this.discussionForm.patchValue({
      discussionId: d.discussionId ?? 0,
      masterType: d.masterType ?? this.masterType,
      masterId: null,
      discTitle: d.displayName ?? "",
      actionUser: this.user?.userId?.toString() ?? "",
    });
    this.masterModalRef = this.modalService.open(this.masterModalContent, {
      size: "md",
      backdrop: "static",
    });
  }

  // deleteDiscussion(d: DiscussionMasterDTO) {
  //   this.confirmModal.openDeleteModal(d.discTitle ?? 'Discussion', d).subscribe(res => {
  //     if (res) {
  //       const payload: DiscussionMasterDeleteRequestDTO = {
  //         discussionId: d.discussionId!,
  //         actionUser: this.user?.userId?.toString() ?? ''
  //       };
  //       this.discussionMasterService.DiscussionMaster_Delete(payload).subscribe({
  //         next: () => {
  //           this.toastr.warning('Discussion deleted');
  //           this.loadDiscussionsPaginated(this.ReadAllPaginatedDTO);
  //         },
  //         error: (err) => {
  //           console.error('Error deleting discussion', err);
  //           this.toastr.error('Failed to delete');
  //         }
  //       });
  //     }
  //   });
  // }

  submitMasterForm() {
    this.discussionForm.markAllAsTouched();
    if (this.discussionForm.invalid) return;

    this.isSubmitting = true;
    const form = this.discussionForm.value;
    const base = {
      masterType: form.masterType,
      masterId: form.masterId,
      discTitle: form.discTitle ?? "",
      discDesc: form.discDesc ?? "",
      postedBy: form.postedBy ?? this.user?.userId?.toString(),
      postedAt: form.postedAt ? new Date(form.postedAt) : undefined,
      actionUser: this.user?.userId?.toString(),
      otherDetail1: form.otherDetail1 ?? "",
      otherDetail2: form.otherDetail2 ?? "",
      otherDetail3: form.otherDetail3 ?? "",
      otherDetail4: form.otherDetail4 ?? "",
      otherDetail5: form.otherDetail5 ?? "",
      otherDetail6: form.otherDetail6 ?? "",
    };

    if (form.discussionId && form.discussionId !== 0) {
      const updatePayload: DiscussionMasterUpdateRequestDTO = {
        ...base,
        discussionId: form.discussionId,
        isActive: 1,
      } as DiscussionMasterUpdateRequestDTO;

      this.discussionMasterService
        .DiscussionMaster_Update(updatePayload)
        .subscribe({
          next: (res) => {
            this.masterModalRef.close();
            this.toastr.success("Discussion updated");

            this.loadDiscussionsPaginated(this.ReadAllPaginatedDTO);

            this.isSubmitting = false;
          },
          error: (err) => {
            this.isSubmitting = false;
          },
        });
    } else {
      const createPayload: DiscussionMasterCreateRequestDTO = {
        ...base,
      } as DiscussionMasterCreateRequestDTO;

      this.discussionMasterService
        .DiscussionMaster_Create(createPayload)
        .subscribe({
          next: (res) => {
            // this.masterModalRef.close();
            this.toastr.success("Discussion created");
            this.loadDiscussionsPaginated(this.ReadAllPaginatedDTO);
            this.isSubmitting = false;
          },
          error: (err) => {
            this.isSubmitting = false;
          },
        });
    }
  }

  private getLoggedInUserId(): number {
    return Number(this.currentUserId ?? this.user?.userId ?? this.User?.userId ?? 0);
  }

  private getLoggedInUserName(): string {
    const userObj: any = this.user || this.User || {};

    return (
      userObj.userName ||
      userObj.fullName ||
      userObj.firstName ||
      userObj.name ||
      'Someone'
    ).toString();
  }

  private sendDiscussionPushNotification(
    receiverUserId: number | string | null | undefined,
    title: string,
    message: string
  ): void {
    const userId = Number(receiverUserId || 0);
    const loggedInUserId = this.getLoggedInUserId();

    if (!userId || userId === loggedInUserId) {
      return;
    }

    const payload: PushNotificationSendMessageRequestDTO = {
      userId: userId.toString(),
      title: title,
      message: message
    };

    this.notificationMasterService
      .PushNotificationConfig_SendMessage(payload)
      .subscribe({
        next: () => {},
        error: (err) => {
          console.error('Discussion push notification failed', err);
        }
      });
  }

  private getParticipantUserId(participant: any): number {
    /*
      IMPORTANT:
      participantId is the DiscussionParticipants table primary key.
      It is NOT the member UserId, so it must never be used while
      comparing participants with the add-member user list.
    */
    return Number(
      participant?.userId ??
      participant?.UserId ??
      participant?.participantUserId ??
      participant?.ParticipantUserId ??
      participant?.postedBy ??
      participant?.PostedBy ??
      0
    );
  }

  private notifyDiscussionParticipants(
    discussionId: number,
    message: string,
    excludeUserId?: number
  ): void {
    if (!discussionId) {
      return;
    }

    const senderName = this.getLoggedInUserName();
    const title = this.isGroupChat
      ? `${senderName} sent a message in ${this.chatTitle || 'Group Chat'}`
      : `New message from ${senderName}`;

    const body = message.length > 120 ? `${message.substring(0, 120)}...` : message;

    this.discussionParticipantsService
      .DiscussionParticipants_ReadByDiscussionId({ discussionId })
      .subscribe({
        next: (res: any) => {
          const participants = res?.items || [];
          const uniqueIds = new Set<number>();
          const currentId = Number(excludeUserId || this.getLoggedInUserId());

          participants.forEach((participant: any) => {
            const participantUserId = this.getParticipantUserId(participant);

            if (participantUserId && participantUserId !== currentId) {
              uniqueIds.add(participantUserId);
            }
          });

          uniqueIds.forEach((participantUserId) => {
            this.sendDiscussionPushNotification(participantUserId, title, body);
          });
        },
        error: (err) => {
          console.error('Failed to fetch discussion participants for notification', err);
        }
      });
  }

  private sendChatCreatedNotification(receiverUserId: number, discussionId: number): void {
    const senderName = this.getLoggedInUserName();

    this.sendDiscussionPushNotification(
      receiverUserId,
      `New chat from ${senderName}`,
      `${senderName} started a chat with you.`
    );
  }

  private sendGroupCreatedNotification(discussionId: number): void {
    if (!discussionId) {
      return;
    }

    const senderName = this.getLoggedInUserName();
    const groupName = this.discussionForm.value.discTitle || 'Group Chat';

    this.discussionParticipantsService
      .DiscussionParticipants_ReadByDiscussionId({ discussionId })
      .subscribe({
        next: (res: any) => {
          const participants = res?.items || [];
          const uniqueIds = new Set<number>();
          const currentId = this.getLoggedInUserId();

          participants.forEach((participant: any) => {
            const participantUserId = this.getParticipantUserId(participant);

            if (participantUserId && participantUserId !== currentId) {
              uniqueIds.add(participantUserId);
            }
          });

          uniqueIds.forEach((participantUserId) => {
            this.sendDiscussionPushNotification(
              participantUserId,
              `Added to ${groupName}`,
              `${senderName} added you to a discussion group.`
            );
          });
        },
        error: (err) => {
          console.error('Failed to send group created notifications', err);
        }
      });
  }

  isOwnMessage(postedBy: any, msg: any): boolean {
    const pbNum = typeof postedBy === "string" ? Number(postedBy) : postedBy;
    return pbNum === (this.currentUserId ?? this.user?.userId);
  }

  startEdit(msg: any) {
    if (this.isMessageDeleted(msg) || this.getMessageAttachmentUrl(msg)) return;
    this.editMessageId = msg.detailId;
    this.editMessageText = msg.discDesc;
  }

  cancelEdit() {
    this.editMessageId = null;
    this.editMessageText = "";
  }

  saveEdit(msg: any) {
    if (!this.editMessageText.trim()) return;
    const newText = this.editMessageText.trim();
    msg.updatedAt = new Date();

    this.editMessageId = null;
    this.editMessageText = "";

    this.updateMessage(msg, newText);
  }

  updateMessage(msg: DiscussionDetailDTO, newText: string) {
    if (!newText || newText.trim() === msg.discDesc) return;

    const payload: DiscussionDetailUpdateRequestDTO = {
      ...msg,
      isActive: 1,
      discDesc: newText.trim(),
      actionUser: (this.currentUserId ?? this.user?.userId).toString(),
    };

    this.discussionDetailService.DiscussionDetail_Update(payload).subscribe({
      next: () => {
        this.toastr.success("Message updated");
        this.refreshVisibleMessages();
      },
      error: (err) => {
        this.toastr.error("Failed to update");
      },
    });
  }

  loadMessages(): Promise<void> {
    if (!this.selectedDiscussionId) return Promise.resolve();

    this.isChatLoading = true;
    this.isMsgGrouping = true;
    const loadToken = ++this.currentLoadToken;

    return new Promise((resolve, reject) => {
      this.discussionDetailService
        .DiscussionDetail_ReadByDiscussionId({
          discussionId: this.selectedDiscussionId!,
          lastDetailId: null,
          pageSize: this.pageSize,
        })
        .subscribe({
          next: (res: DiscussionDetailList) => {
            if (loadToken !== this.currentLoadToken) return;

            const items: DiscussionDetailDTO[] = (res.items ?? []).map((i) => ({
              ...i,
            }));

            items.sort(
              (a, b) => +new Date(a.createdOn!) - +new Date(b.createdOn!),
            );

            this.discussionDetails = items.map(item => this.normalizeDiscussionMessage(item));

            this.lastDetailId = items.length > 0 ? items[0].detailId! : null;

            this.groupMessagesByDate(this.discussionDetails);
            setTimeout(() => {
              this.scrollToBottom();
              this.markAsRead(); // ✅ REQUIRED
            }, 100);

            resolve();
          },
          error: (err) => {
            if (loadToken === this.currentLoadToken) {
              this.isChatLoading = false;
              this.isMsgGrouping = false;
            }
            reject(err);
          },
        });
    });
  }

  groupMessagesByDate(messages: DiscussionDetailDTO[]) {
    if (messages.length === 0) {
      this.groupedMessages = [];
      this.isChatLoading = false; // ✅ Reset here
      this.isMsgGrouping = false;
      return;
    }

    const today = new Date();
    const yesterday = new Date();
    yesterday.setDate(today.getDate() - 1);

    const groups: { [key: string]: DiscussionDetailDTO[] } = {};

    messages.forEach((msg) => {
      const msgDate = new Date(msg.createdOn!);
      const label = this.getDateLabel(msgDate, today, yesterday);

      if (!groups[label]) groups[label] = [];
      groups[label].push(msg);
    });

    Object.keys(groups).forEach((label) => {
      groups[label].sort(
        (a, b) => +new Date(a.createdOn!) - +new Date(b.createdOn!),
      );
    });

    this.groupedMessages = Object.keys(groups)
      .map((label) => ({
        label,
        messages: groups[label],
      }))
      .sort((a, b) => {
        const dateA = new Date(a.messages[0].createdOn!);
        const dateB = new Date(b.messages[0].createdOn!);
        return dateA.getTime() - dateB.getTime();
      });

    this.isChatLoading = false;
    this.isMsgGrouping = false;
  }

  getDateLabel(date: Date, today: Date, yesterday: Date): string {
    if (date.toDateString() === today.toDateString()) return "Today";
    if (date.toDateString() === yesterday.toDateString()) return "Yesterday";

    const diffDays = Math.floor(
      (today.getTime() - date.getTime()) / (1000 * 60 * 60 * 24),
    );
    if (diffDays < 7) {
      return date.toLocaleDateString("en-US", { weekday: "long" });
    }

    return date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  }

  scrollToBottom() {
    try {
      this.bottomAnchor.nativeElement.scrollIntoView({ behavior: "smooth" });
    } catch {}
  }

  selectedMessageToDelete: DiscussionDetailDTO | null = null;

  deleteMessage(msg: DiscussionDetailDTO) {
    if (this.isMessageDeleted(msg) || !this.isOwnMessage(msg.postedBy, msg)) return;
    this.selectedMessageToDelete = msg;

    const popup = document.getElementById("deletePopup");
    if (popup) popup.style.display = "flex";
  }

  confirmDeleteMessage() {
    if (!this.selectedMessageToDelete) return;

    const msg = this.selectedMessageToDelete;

    const payload: DiscussionDetailDeleteRequestDTO = {
      detailId: msg.detailId!,
      actionUser: (this.currentUserId ?? this.user?.userId).toString(),
    };

    this.discussionDetailService.DiscussionDetail_Delete(payload).subscribe({
      next: () => {
        // Keep a WhatsApp-style placeholder immediately, without changing the
        // rest of the loaded conversation or resetting the scroll position.
        this.applyDeletedMessage(Number(msg.detailId));
        this.toastr.warning("Message deleted");
        this.refreshVisibleMessages();
      },
      error: () => {
        this.toastr.error("Failed to delete message");
      },
    });

    const popup = document.getElementById("deletePopup");
    if (popup) popup.style.display = "none";

    this.selectedMessageToDelete = null;
  }

  cancelDelete() {
    const popup = document.getElementById("deletePopup");
    if (popup) popup.style.display = "none";
    this.selectedMessageToDelete = null;
  }

  public async sendMessage(): Promise<void> {
    const messageText = (this.newMessage || "").trim();
    const selectedFile = this.selectedAttachment;
    const selectedDiscussionId = this.selectedDiscussionId;

    if ((!messageText && !selectedFile) || !selectedDiscussionId || this.isSubmitting) {
      return;
    }

    this.isSubmitting = true;
    try {
      const currentUserId = this.getLoggedInUserId();
      let fileUrl = "";

      // Upload binary files first; the message stores only the durable URL.
      // Never store a large base64 recording/file in the DiscussionDetail fields.
      if (selectedFile) {
        const formData = new FormData();
        formData.append("file", selectedFile, selectedFile.name);
        const result: any = await firstValueFrom(
          this.http.post<any>(this.attachmentUploadUrl, formData)
        );
        const uploaded = result?.items?.[0] ?? result?.Items?.[0] ??
          result?.data?.items?.[0] ?? result?.Data?.Items?.[0] ??
          result?.data ?? result?.Data ?? result;
        fileUrl = String(
          uploaded?.url ?? uploaded?.Url ?? uploaded?.fileUrl ?? uploaded?.FileUrl ??
          uploaded?.imageUrl ?? uploaded?.ImageUrl ?? uploaded?.attachmentUrl ??
          uploaded?.AttachmentUrl ?? uploaded?.path ?? uploaded?.Path ??
          (typeof uploaded === "string" ? uploaded : "")
        ).trim();

        if (!this.isSafeAttachmentUrl(fileUrl)) {
          throw new Error("Attachment API did not return a valid HTTPS or relative file URL.");
        }
      }

      const isAudio = !!selectedFile && selectedFile.type.startsWith("audio/");
      const messageDescription = messageText;

      const payload = {
        discussionId: selectedDiscussionId,
        postedBy: currentUserId.toString(),
        discDesc: messageDescription,
        actionUser: currentUserId.toString(),
        postedAt: new Date(),
        otherDetail1: selectedFile ? "ATTACHMENT" : "",
        otherDetail2: selectedFile ? (isAudio ? "audio" : selectedFile.type.startsWith("image/") ? "image" : "file") : "",
        otherDetail3: selectedFile ? (selectedFile.name.split(".").pop() || "").toLowerCase() : "",
        otherDetail4: "",
        otherDetail5: fileUrl,
        otherDetail6: selectedFile?.name || "",
        ...(selectedFile ? {
          attachmentUrl: fileUrl,
          attachmentType: isAudio ? "audio" : selectedFile.type.startsWith("image/") ? "image" : "file",
          attachementUrl: fileUrl,
          attachementType: isAudio ? "audio" : selectedFile.type.startsWith("image/") ? "image" : "file"
        } : {}),
      };

      await firstValueFrom(this.discussionDetailService.DiscussionDetail_Create(payload));

      this.notifyDiscussionParticipants(
        selectedDiscussionId,
        messageDescription,
        currentUserId
      );

      // Avoid clearing a draft entered in a different chat while upload was pending.
      if (this.selectedDiscussionId === selectedDiscussionId) {
        this.newMessage = "";
        this.clearSelectedAttachment();
        this.refreshVisibleMessages();
      }
    } catch (err: any) {
      console.error("Unable to send discussion message", err);
      this.toastr.error(
        err?.error?.message || err?.message || "Message could not be sent. Please retry."
      );
    } finally {
      this.isSubmitting = false;
    }
  }

  getUserImage(userId: string | number): string {
    const user = this.userCache[userId?.toString()];
    if (user && user.profileImage && user.profileImage.trim() !== "") {
      return user.profileImage;
    }
    return "assets/SchoolModule/images/user.svg";
  }

  onImageError(event: Event) {
    const imgElement = event.target as HTMLImageElement | null;
    if (!imgElement) return;

    imgElement.src = this.isGroupChat
      ? "assets/SchoolModule/images/group.svg"
      : "assets/SchoolModule/images/user.svg";
  }

  formatDiscussionTime(dateString: string | Date): string {
    if (!dateString) return "";

    const date = new Date(dateString);
    const today = new Date();

    const isToday =
      date.getDate() === today.getDate() &&
      date.getMonth() === today.getMonth() &&
      date.getFullYear() === today.getFullYear();

    if (isToday) {
      return date.toLocaleTimeString("en-US", {
        hour: "2-digit",
        minute: "2-digit",
      });
    }

    return "Yesterday";
  }

  setChatHeader(discussion?: DiscussionDTO) {
    if (this.isGroupChat) {
      this.chatTitle = discussion?.displayName || "Group Chat";
      this.chatSubtitle = "";
    } else {
      this.chatTitle = discussion?.displayName || "Private Chat";
      this.chatSubtitle = "";
    }

    const img = discussion?.displayImage?.trim();

    if (img) return img;

    return this.isGroupChat
      ? "assets/SchoolModule/images/group.svg"
      : "assets/SchoolModule/images/user.svg";
  }

  toggleSelection(user: any) {
    if (this.isSingleSelectMode) {
      this.userList.forEach((u) => (u.selected = false));

      user.selected = true;

      this.updateSelectedCount();

      return;
    }
    user.selected = !user.selected;
    this.updateSelectedCount();
  }

  toggleSelectAll(event: any) {
    if (this.isSingleSelectMode) return;
    const checked = event.target.checked;

    this.userList.forEach((u) => (u.selected = checked));

    this.updateSelectedCount();
  }

  updateSelectedCount() {
    const selected = this.userList.filter((u) => u.selected);
    this.selectedCount = selected.length;

    this.selectedUserIds = selected.map((u) => u.userId);
  }

  allSelected() {
    return this.userList.length > 0 && this.userList.every((u) => u.selected);
  }

  closePanel() {
    this.isGroupMode = false;
    this.isPanelOpen = false;
    this.showListType = false;
    this.showClassSection = false;
    this.userList.forEach((u) => (u.selected = false));
    this.selectedUserIds = [];
    this.selectedCount = 0;
  }

  onCreateChat() {
    const selectedIds = this.getSelectedUserIds();

    if (selectedIds.length === 0) {
      this.toastr.warning("Please select a user!");
      return;
    }
    this.createOneToOneChat(selectedIds[0]);
  }

  getSelectedUserIds(): number[] {
    return this.userList.filter((u) => u.selected).map((u) => u.userId);
  }

  createOneToOneChat(otherUserId: number) {
    this.chatCreating = true;
    this.discussionMasterService
      .DiscussionMaster_GetOrCreateOneToOne({
        otherUserId: otherUserId,
        actionUser: this.currentUserId,
      })
      .subscribe({
        next: (res) => {
          this.discussionId = res.discussionId;
          const newDiscussionId = res.discussionId;

          this.sendChatCreatedNotification(otherUserId, newDiscussionId);

          this.closePanel();
          this.refreshDiscussionListAndSelect(newDiscussionId);

          this.chatCreating = false;
        },
        error: (err) => {
          this.chatCreating = false;
        },
      });
  }

  refreshDiscussionListAndSelect(discussionId: number) {
    this.discussionLoading = true;

    const payload: DiscussionMasterReadByUserIdRequestDTO = {
      ...this.ReadAllPaginatedDTO,
      userId: this.currentUserId!,
      pageNo: 1,
      pageSize: this.ReadAllPaginatedDTO.pageSize,
    };

    this.discussionMasterService
      .DiscussionMaster_GetDiscussionList(payload)
      .subscribe({
        next: (res: DiscussionListing) => {
          const items = res.items ?? [];

          const target = items.find(
            (d) => d.discussionId === discussionId,
          );

          this.discussions = target
            ? [
                target,
                ...items.filter(
                  (d) => d.discussionId !== discussionId,
                ),
              ]
            : items;

          if (target) {
            this.previousDiscussionId = undefined;
            this.selectedDiscussionId = discussionId;
            this.onDiscussionSelected(target);
          }

          this.discussionLoading = false;
          this.updateChatListWebSocket(discussionId);
        },
        error: (err) => {
          this.discussionLoading = false;
        },
      });
  }

  createGroupChat() {
    if (this.discussionForm.invalid) {
      this.discussionForm.markAllAsTouched();
      return;
    }

    if (this.selectedUserIds.length < 2) {
      this.toastr.warning('Please select at least 2 users to create a group.');
      return;
    }

    const payload: DiscussionMasterCreateGroupRequestDTO = {
      discTitle: this.discussionForm.value.discTitle!,
      actionUser: this.currentUserId!,
      userList: this.selectedUserIds.join(','),
      canMembersPost: this.discussionForm.value.canMembersPost ? 1 : 0,
    };

    this.groupChatCreating = true;

    this.discussionMasterService
      .DiscussionMaster_CreateGroup(payload)
      .subscribe({
        next: (res) => {
          this.groupChatCreating = false;

          const newDiscussionId = res.discussionId;

          this.sendGroupCreatedNotification(newDiscussionId);

          this.closePanel();
          this.refreshDiscussionListAndSelect(newDiscussionId);
        },
        error: (err) => {
          this.groupChatCreating = false;
        },
      });
  }

  deleteCurrentGroup(): void {
    if (
      !this.selectedDiscussionId ||
      !this.selectedDiscussion ||
      !this.isGroupChat
    ) {
      this.toastr.warning("Please select a group first.");
      return;
    }

    if (!this.canManageGroupMembers()) {
      this.toastr.warning("Only the group admin can remove this group.");
      return;
    }

    const groupName =
      this.selectedDiscussion.displayName ||
      this.chatTitle ||
      "this group";

    this.confirmModal
      .openDeleteModal(groupName, this.selectedDiscussion)
      .subscribe((confirmed: boolean) => {
        if (!confirmed || !this.selectedDiscussionId) {
          return;
        }

        this.deletingGroup = true;

        const payload: DiscussionMasterDeleteRequestDTO = {
          discussionId: this.selectedDiscussionId,
          actionUser: this.getLoggedInUserId().toString(),
        };

        this.discussionMasterService
          .DiscussionMaster_Delete(payload)
          .subscribe({
            next: () => {
              this.deletingGroup = false;
              this.toastr.success("Group removed successfully.");

              if (this.wsSubscription) {
                this.wsSubscription.unsubscribe();
              }

              this.webSocketService.close();
              this.stopMessageRefresh();
              this.stopVoiceToText();
              this.releaseMediaRecording();
              this.clearSelectedAttachment();
              this.currentLoadToken++;

              this.previousDiscussionId = undefined;
              this.selectedDiscussionId = undefined;
              this.selectedDiscussion = null;
              this.isGroupChat = false;
              this.chatTitle = "";
              this.chatSubtitle = "";
              this.chatHeaderImage =
                "assets/SchoolModule/images/user.svg";
              this.participantsList = [];
              this.discussionDetails = [];
              this.groupedMessages = [];

              this.ReadAllPaginatedDTO.pageNo = 1;
              this.loadDiscussionsPaginated(
                this.ReadAllPaginatedDTO,
              );
              this.updateChatListWebSocket();
            },
            error: (err) => {
              this.deletingGroup = false;

              const apiMessage =
                err?.error?.message ||
                err?.error?.responseMessage ||
                err?.error?.title ||
                "Failed to remove group.";

              this.toastr.error(apiMessage);
            },
          });
      });
  }

  openParticipantsModal() {
    this.participantsModalRef = this.modalService.open(
      this.participantsModalContent,
      { size: "md", backdrop: "static" },
    );
  }

  loadParticipants() {
    if (this.selectedDiscussionId) {
      this.loadingParticipants = true;
      this.discussionParticipantsService
        .DiscussionParticipants_ReadByDiscussionId({
          discussionId: this.selectedDiscussionId,
        })
        .subscribe({
          next: (res: any) => {
            const items = res?.items ?? res?.Items ?? [];

            this.participantsList = items.map((participant: any) => ({
              ...participant,
              participantId:
                participant?.participantId ??
                participant?.ParticipantId ??
                0,
              discussionId:
                participant?.discussionId ??
                participant?.DiscussionId ??
                this.selectedDiscussionId,
              userId:
                participant?.userId ??
                participant?.UserId ??
                participant?.participantUserId ??
                participant?.ParticipantUserId ??
                0,
              userName:
                participant?.userName ??
                participant?.UserName ??
                "",
              profileImage:
                participant?.profileImage ??
                participant?.ProfileImage ??
                "assets/SchoolModule/images/user.svg",
              participantRole:
                participant?.participantRole ??
                participant?.ParticipantRole ??
                "",
              canPost:
                participant?.canPost ??
                participant?.CanPost ??
                1,
            }));

            this.loadingParticipants = false;
          },
          error: (err) => {
            console.error("Participant list load failed", err);
            this.participantsList = [];
            this.loadingParticipants = false;
          },
        });
    }
  }


  private addMemberSubscriptionsReady = false;

  private setupAddMemberSubscriptions(): void {
    if (this.addMemberSubscriptionsReady) {
      return;
    }

    this.addMemberSubscriptionsReady = true;

    this.addMemberForm.get("listType")?.valueChanges.subscribe((type) => {
      const normalizedType = String(type || "staff").toLowerCase();

      this.addMemberShowClassSection =
        normalizedType === "student" || normalizedType === "parent";

      this.addMemberForm.patchValue(
        {
          classId: null,
          sectionId: null,
        },
        { emitEvent: false },
      );

      this.addMemberSectionList = [];
      this.loadAvailableMembers();
    });

    this.addMemberForm.get("classId")?.valueChanges.subscribe((classId) => {
      this.addMemberForm.patchValue(
        { sectionId: null },
        { emitEvent: false },
      );

      this.addMemberSectionList = [];

      if (classId) {
        this.loadAddMemberSections(Number(classId));
      } else {
        this.loadAvailableMembers();
      }
    });

    this.addMemberForm.get("sectionId")?.valueChanges.subscribe(() => {
      this.loadAvailableMembers();
    });

    this.addMemberSearchControl.valueChanges
      .pipe(debounceTime(350), distinctUntilChanged())
      .subscribe(() => {
        this.loadAvailableMembers();
      });
  }

  private isOwnerSide(): boolean {
    const affiliation = String(this.affiliationType || "").toLowerCase();
    const roleIds = String(this.user?.roleId || "")
      .split(",")
      .map((x: string) => Number(x.trim()))
      .filter((x: number) => !isNaN(x));

    return (
      roleIds.includes(5) ||
      roleIds.includes(25) ||
      affiliation.includes("school admin") ||
      affiliation.includes("school-owner") ||
      affiliation.includes("spe_school-owner") ||
      affiliation === "owner"
    );
  }

  canManageGroupMembers(): boolean {
    if (!this.isGroupChat || !this.selectedDiscussionId || !this.isOwnerSide()) {
      return false;
    }

    const currentUserId = this.getLoggedInUserId();

    const currentParticipant = this.participantsList.find(
      (participant: any) => this.getParticipantUserId(participant) === currentUserId,
    );

    if (!currentParticipant) {
      return this.isOwnerSide();
    }

    const role = String(
      (currentParticipant as any)?.participantRole || "",
    ).toLowerCase();

    return (
      role.includes("groupadmin") ||
      role.includes("group admin") ||
      role.includes("admin") ||
      this.isOwnerSide()
    );
  }

  private loadParticipantsForAddMember(): Promise<void> {
    if (!this.selectedDiscussionId) {
      return Promise.resolve();
    }

    this.addMemberLoading = true;

    return new Promise((resolve) => {
      this.discussionParticipantsService
        .DiscussionParticipants_ReadByDiscussionId({
          discussionId: this.selectedDiscussionId!,
        })
        .subscribe({
          next: (res: any) => {
            const items = res?.items ?? res?.Items ?? [];

            this.participantsList = items.map((participant: any) => ({
              ...participant,
              participantId:
                participant?.participantId ??
                participant?.ParticipantId ??
                0,
              discussionId:
                participant?.discussionId ??
                participant?.DiscussionId ??
                this.selectedDiscussionId,
              userId:
                participant?.userId ??
                participant?.UserId ??
                participant?.participantUserId ??
                participant?.ParticipantUserId ??
                0,
              userName:
                participant?.userName ??
                participant?.UserName ??
                "",
              profileImage:
                participant?.profileImage ??
                participant?.ProfileImage ??
                "assets/SchoolModule/images/user.svg",
              participantRole:
                participant?.participantRole ??
                participant?.ParticipantRole ??
                "",
              canPost:
                participant?.canPost ??
                participant?.CanPost ??
                1,
            }));

            resolve();
          },
          error: (err) => {
            console.error("Unable to refresh participants before add member", err);
            resolve();
          },
        });
    });
  }

  async openAddMembersModal(): Promise<void> {
    if (!this.selectedDiscussionId || !this.isGroupChat) {
      this.toastr.warning("Please select a group first.");
      return;
    }

    if (!this.canManageGroupMembers()) {
      this.toastr.warning("Only the group admin can manage members.");
      return;
    }

    /*
      Always refresh the current group participants before showing
      the add-member list. This prevents already-added users from
      appearing because of an old/stale participantsList.
    */
    await this.loadParticipantsForAddMember();

    this.selectedAddMemberIds = [];
    this.addMemberUserList = [];
    this.addMemberSearchControl.setValue("", { emitEvent: false });

    const defaultType = this.allowedListTypes?.includes("staff")
      ? "staff"
      : this.allowedListTypes?.[0] || "staff";

    this.addMemberForm.patchValue(
      {
        listType: defaultType,
        classId: null,
        sectionId: null,
      },
      { emitEvent: false },
    );

    this.addMemberShowClassSection =
      defaultType === "student" || defaultType === "parent";

    this.addMembersModalRef = this.modalService.open(
      this.addMembersModalContent,
      {
        size: "lg",
        backdrop: "static",
        centered: true,
      },
    );

    this.loadAvailableMembers();
  }

  loadAddMemberSections(classId: number): void {
    if (!classId) {
      this.addMemberSectionList = [];
      this.loadAvailableMembers();
      return;
    }

    this.addMemberLoadingSections = true;
    this.addMemberSectionList = [];

    this.sectionMasterService
      .SectionMaster_ReadByClassId({ classId })
      .subscribe({
        next: (res) => {
          this.addMemberSectionList = res.items || [];
          this.addMemberLoadingSections = false;
          this.loadAvailableMembers();
        },
        error: () => {
          this.addMemberSectionList = [];
          this.addMemberLoadingSections = false;
          this.loadAvailableMembers();
        },
      });
  }

  loadAvailableMembers(): void {
    if (!this.selectedSchoolId || !this.selectedDiscussionId) {
      return;
    }

    const listType = String(
      this.addMemberForm.get("listType")?.value || "staff",
    ).toLowerCase();

    const classId = this.addMemberForm.get("classId")?.value;
    const sectionId = this.addMemberForm.get("sectionId")?.value;
    const searchText = String(
      this.addMemberSearchControl.value || "",
    ).trim();

    if (
      (listType === "student" || listType === "parent") &&
      !classId
    ) {
      this.addMemberUserList = [];
      this.addMemberLoading = false;
      return;
    }

    const payload: DiscussionMasterGetDiscussionUserListRequestDTO = {
      schoolId: Number(this.selectedSchoolId),
      listType,
      classId: classId ? Number(classId) : null,
      sectionId: sectionId ? Number(sectionId) : null,
      pageNo: 1,
      pageSize: 100,
      whereClause: searchText,
    };

    this.addMemberLoading = true;

    this.discussionMasterService
      .DiscussionMaster_GetDiscussionUserList(payload)
      .subscribe({
        next: (res: any) => {
          const existingParticipantIds = new Set<number>(
            (this.participantsList || [])
              .map((participant: any) => this.getParticipantUserId(participant))
              .filter((id: number) => id > 0),
          );

          /*
            Username fallback is only used when an older API response
            does not return UserId. Primary filtering always remains UserId.
          */
          const existingParticipantNames = new Set<string>(
            (this.participantsList || [])
              .map((participant: any) =>
                String(
                  participant?.userName ??
                  participant?.UserName ??
                  "",
                )
                  .trim()
                  .toLowerCase(),
              )
              .filter((name: string) => !!name),
          );

          const currentUserId = this.getLoggedInUserId();
          const items = res?.items ?? res?.Items ?? [];

          this.addMemberUserList = items
            .filter((item: any) => {
              const itemUserId = Number(item?.userId ?? item?.UserId ?? 0);
              const itemUserName = String(
                item?.userName ?? item?.UserName ?? "",
              )
                .trim()
                .toLowerCase();

              return (
                itemUserId !== currentUserId &&
                !existingParticipantIds.has(itemUserId) &&
                !existingParticipantNames.has(itemUserName)
              );
            })
            .map((item: any) => ({
              ...item,
              selected: this.selectedAddMemberIds.includes(
                Number(item.userId),
              ),
              profileImage:
                item.profileImage ||
                "assets/SchoolModule/images/user.svg",
            }));

          this.addMemberLoading = false;
        },
        error: () => {
          this.addMemberUserList = [];
          this.addMemberLoading = false;
        },
      });
  }

  toggleAddMemberSelection(user: DiscussionUserDTO): void {
    user.selected = !user.selected;

    this.selectedAddMemberIds = this.addMemberUserList
      .filter((item) => item.selected)
      .map((item) => Number(item.userId));
  }

  allAddMembersSelected(): boolean {
    return (
      this.addMemberUserList.length > 0 &&
      this.addMemberUserList.every((item) => item.selected)
    );
  }

  toggleSelectAllAddMembers(event: Event): void {
    const checked = (event.target as HTMLInputElement).checked;

    this.addMemberUserList.forEach((item) => {
      item.selected = checked;
    });

    this.selectedAddMemberIds = checked
      ? this.addMemberUserList.map((item) => Number(item.userId))
      : [];
  }

  addSelectedMembers(): void {
    if (!this.selectedDiscussionId) {
      return;
    }

    if (this.selectedAddMemberIds.length === 0) {
      this.toastr.warning("Please select at least one member.");
      return;
    }

    this.addingMembers = true;

    const discussionId = this.selectedDiscussionId;
    const actionUser = this.getLoggedInUserId().toString();
    const canPost = this.discussionForm.value.canMembersPost === false ? 0 : 1;

    const requests = this.selectedAddMemberIds.map(
      (userId) =>
        new Promise<void>((resolve, reject) => {
          const payload: DiscussionParticipantsCreateRequestDTO = {
            discussionId,
            userId,
            canPost,
            participantRole: "Member",
            joinedOn: new Date(),
            leftOn: null,
            otherDetail1: "",
            otherDetail2: "",
            otherDetail3: "",
            otherDetail4: "",
            otherDetail5: "",
            otherDetail6: "",
            actionUser,
          };

          this.discussionParticipantsService
            .DiscussionParticipants_Create(payload)
            .subscribe({
              next: () => {
                this.sendDiscussionPushNotification(
                  userId,
                  `Added to ${this.chatTitle || "Group Chat"}`,
                  `${this.getLoggedInUserName()} added you to the discussion group.`,
                );
                resolve();
              },
              error: (err) => {
                console.error("Add group member failed", err);
                reject(err);
              },
            });
        }),
    );

    Promise.all(requests)
      .then(() => {
        this.toastr.success(
          `${this.selectedAddMemberIds.length} member(s) added successfully.`,
        );

        this.selectedAddMemberIds = [];
        this.addingMembers = false;
        this.addMembersModalRef?.close();

        this.loadParticipants();
        this.refreshDiscussionListAndSelect(discussionId);
      })
      .catch((err) => {
        this.addingMembers = false;

        const apiMessage =
          err?.error?.message ||
          err?.error?.responseMessage ||
          err?.error?.title ||
          "Some members could not be added.";

        this.toastr.error(apiMessage);
        this.loadParticipants();
        this.loadAvailableMembers();
      });
  }

  canRemoveParticipant(participant: any): boolean {
    if (!this.canManageGroupMembers()) {
      return false;
    }

    const participantUserId = this.getParticipantUserId(participant);
    const currentUserId = this.getLoggedInUserId();
    const role = String(participant?.participantRole || "").toLowerCase();

    return (
      participantUserId > 0 &&
      participantUserId !== currentUserId &&
      !role.includes("groupadmin") &&
      !role.includes("group admin")
    );
  }

  removeParticipant(participant: any): void {
    if (!this.selectedDiscussionId || !this.canRemoveParticipant(participant)) {
      return;
    }

    const participantId = Number(participant?.participantId || 0);

    if (!participantId) {
      this.toastr.error("Participant id not found.");
      return;
    }

    const memberName = participant?.userName || "this member";

    this.confirmModal
      .openDeleteModal(memberName, participant)
      .subscribe((confirmed: boolean) => {
        if (!confirmed) {
          return;
        }

        this.removingParticipantId = participantId;

        const payload: DiscussionParticipantsDeleteRequestDTO = {
          participantId,
          actionUser: this.getLoggedInUserId().toString(),
        };

        this.discussionParticipantsService
          .DiscussionParticipants_Delete(payload)
          .subscribe({
            next: () => {
              this.removingParticipantId = null;
              this.toastr.success("Member removed from group.");
              this.loadParticipants();
              this.refreshDiscussionListAndSelect(
                this.selectedDiscussionId!,
              );
            },
            error: () => {
              this.removingParticipantId = null;
              this.toastr.error("Failed to remove member.");
            },
          });
      });
  }

  private restoreOriginalText(el: any) {
    const textNode = el.querySelector(".msg-text");
    if (textNode) {
      el.classList.remove("message-highlight");
      el.style.backgroundColor = "";

      const originalText = textNode.getAttribute("data-original-text");
      if (originalText !== null) {
        textNode.innerHTML = originalText;
        textNode.removeAttribute("data-original-text");
      }
    }
  }

  private highlightMatchText(
    el: any,
    searchText: string,
    isCurrent: boolean = false,
  ) {
    const textNode = el.querySelector(".msg-text");
    if (!textNode) return;

    if (!textNode.hasAttribute("data-original-text")) {
      textNode.setAttribute("data-original-text", textNode.textContent || "");
    }

    const originalText =
      textNode.getAttribute("data-original-text") || textNode.textContent || "";
    const regex = new RegExp(`(${searchText})`, "gi");

    let highlightedHtml = originalText.replace(regex, (match: string) => {
      return `<span class="search-match">${match}</span>`;
    });

    textNode.innerHTML = highlightedHtml;

    if (isCurrent) {
      this.applyCurrentMatchHighlight(el);
    }
  }

  private applyCurrentMatchHighlight(el: any) {
    this.searchResults.forEach((result: any) => {
      result.style.backgroundColor = "";
    });

    el.style.backgroundColor = "#90CAF9";
    el.style.color = "#00000";

    const textNode = el.querySelector(".msg-text");
    const firstMatch = textNode?.querySelector(".search-match");
  }

  toggleMessageSearch() {
    this.showMessageSearch = !this.showMessageSearch;

    if (!this.showMessageSearch) {
      this.closeSearch();
    }
  }

  closeSearch() {
    this.showMessageSearch = false;
    this.searchMessageText = "";

    const container = document.querySelector(".chat-body");
    if (container) {
      container
        .querySelectorAll(".incoming-msg, .outgoing-msg")
        .forEach((el: any) => {
          this.restoreOriginalText(el);
        });
    }

    this.searchResults = [];
    this.currentMatchIndex = 0;
  }

  performMessageSearch() {
    this.searchResults = [];
    this.currentMatchIndex = 0;

    const container = document.querySelector(".chat-body");
    if (!container) return;

    const searchText = this.searchMessageText.trim().toLowerCase();
    if (!searchText) return;

    container
      .querySelectorAll(".incoming-msg, .outgoing-msg")
      .forEach((el: any) => {
        this.restoreOriginalText(el);
      });

    container
      .querySelectorAll(".incoming-msg, .outgoing-msg")
      .forEach((el: any) => {
        const text = el.innerText.toLowerCase();
        if (text.includes(searchText)) {
          this.searchResults.push(el);
          el.classList.add("message-highlight");

          this.highlightMatchText(el, searchText);
        }
      });

    if (this.searchResults.length > 0) {
      this.scrollToElement(this.searchResults[0]);
    } else {
      if (this.searchMessageText.trim().length > 0) {
        this.toastr.warning(
          `No messages found matching "${this.searchMessageText.trim()}"`,
        );
      }
    }
  }

  gotoNextMatch() {
    if (this.currentMatchIndex < this.searchResults.length - 1) {
      this.currentMatchIndex++;
      this.scrollToElement(this.searchResults[this.currentMatchIndex]);
    }
  }

  gotoPrevMatch() {
    if (this.currentMatchIndex > 0) {
      this.currentMatchIndex--;
      this.scrollToElement(this.searchResults[this.currentMatchIndex]);
    }
  }

  scrollToElement(el: HTMLElement) {
    el.scrollIntoView({ behavior: "smooth", block: "center" });
    this.applyCurrentMatchHighlight(el);
  }

  getOldMessages() {
    if (this.isLoadingOld || !this.lastDetailId || !this.hasMoreOldMessages)
      return;

    this.isLoadingOld = true;
    const container = document.querySelector(
      ".chat-scroll-container",
    ) as HTMLElement;
    const oldScrollHeight = container.scrollHeight;

    this.discussionDetailService
      .DiscussionDetail_ReadByDiscussionId({
        discussionId: this.selectedDiscussionId!,
        lastDetailId: this.lastDetailId,
        pageSize: this.pageSize,
      })
      .subscribe({
        next: (res) => {
          if (!res.items || res.items.length === 0) {
            this.hasMoreOldMessages = false;
            this.isLoadingOld = false;
            return;
          }

          const olderMessages: any[] = [];

          res.items.forEach((raw: any) => {
            const item: any = this.normalizeDiscussionMessage(raw);
            const detailId = item.detailId ?? item.DetailId;

            const alreadyExists = this.discussionDetails.some(
              (m) => m.detailId === detailId,
            );

            if (alreadyExists) return;

            olderMessages.push(item);
          });

          // ✅ prepend older messages ONCE
          this.discussionDetails = [
            ...olderMessages,
            ...this.discussionDetails,
          ];

          // ✅ ensure correct order
          this.discussionDetails.sort((a, b) => +a.createdOn! - +b.createdOn!);

          // ✅ update pagination cursor
          this.lastDetailId = this.discussionDetails.length
            ? this.discussionDetails[0].detailId
            : null;

          this.groupMessagesByDate(this.discussionDetails);

          // ✅ maintain scroll position
          setTimeout(() => {
            const newScrollHeight = container.scrollHeight;
            container.scrollTop = newScrollHeight - oldScrollHeight;
          }, 30);

          this.isLoadingOld = false;
        },
        error: () => {
          this.isLoadingOld = false;
        },
      });
  }

  onUserListScroll(event: Event) {
    const el = event.target as HTMLElement;

    if (
      el.scrollTop + el.clientHeight >= el.scrollHeight - 20 &&
      !this.isUserFetchingMore &&
      this.hasMoreUsers
    ) {
      this.loadMoreUsers();
    }
  }

  loadMoreUsers() {
    if (!this.hasMoreUsers || this.isUserFetchingMore) return;
    this.isUserFetchingMore = true;
    this.userPageSize += 10;
    const { listType, classId, sectionId } = this.filterForm.value;
    this.getUserList(listType!, classId, sectionId);
  }

  onScroll(e: any) {
    if (e.target.scrollTop <= 0 && !this.isLoadingOld) {
      this.getOldMessages();
    }
  }

  private markAsRead(): void {
    if (!this.selectedDiscussionId || !this.discussionDetails.length) return;

    const latestDetailId =
      this.discussionDetails[this.discussionDetails.length - 1].detailId;

    if (!latestDetailId) return;

    if (latestDetailId <= this.lastMarkedReadDetailId!) return;

    this.lastMarkedReadDetailId = latestDetailId;

    this.discussionDetailService
      .DiscussionDetail_MarkAsRead({
        userId: this.currentUserId!,
        discussionId: this.selectedDiscussionId,
        lastDetailId: latestDetailId,
      })
      .subscribe({
        next: () => {
          const chat = this.discussions.find(
            (d) => d.discussionId === this.selectedDiscussionId,
          );

          if (chat) {
            chat.unreadCount = 0;
          }
        },
        error: (err) => console.error("Mark as read failed", err),
      });
  }

  onDiscussionScroll(event: Event) {
    const el = event.target as HTMLElement;
    const currentScrollPosition = Math.ceil(el.scrollTop + el.clientHeight);
    const bottomThreshold = el.scrollHeight - 50;

    if (currentScrollPosition >= bottomThreshold) {
      if (!this.isFetchingMore && this.hasMoreDiscussions) {
        this.isFetchingMore = true;

        this.ReadAllPaginatedDTO.pageSize += 15;
        this.loadDiscussionsPaginated(this.ReadAllPaginatedDTO, true);
      }
    }
  }
}
